var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-136",
    d: "M88.52,449.63c-89.19-51.49-89.19-135,0-186.47s233.78-51.49,323,0,89.19,135,0,186.47S177.7,501.12,88.52,449.63Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-136",
    d: "M137.85,375.67c14.31,8.26,14.31,21.66,0,29.92s-37.52,8.26-51.83,0-14.31-21.66,0-29.92S123.54,367.41,137.85,375.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M358.74,329c50,28.86,50,75.64,0,104.49s-131,28.86-181,0-50-75.63,0-104.49S308.77,300.15,358.74,329Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M346.33,304.11c-22.4,12.94-22.4,33.91,0,46.85s58.74,12.94,81.14,0,22.41-33.91,0-46.85S368.74,291.18,346.33,304.11Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.4,393.6c11.49-11.85,18.24-60.08,7-69.48h-57c-11.2,9.39-4.47,57.61,7,69.47l.32.32.39.39c.33.32.67.63,1,.94l.28.21c.28.23.56.45.86.67a16.31,16.31,0,0,0,1.49,1c9.44,5.51,24.76,5.51,34.21,0h0c.51-.29,1-.62,1.5-1,.28-.2.54-.41.8-.62s.23-.17.34-.27a12.49,12.49,0,0,0,1-.9c.16-.14.31-.3.46-.45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38,320.33c-13,7.59-13,19.91,0,27.5s34.09,7.59,47.09,0,13-19.9,0-27.5S101.39,312.74,88.38,320.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,324c-9.55,5.58-9.55,14.62,0,20.2s25,5.57,34.59,0,9.55-14.62,0-20.2S104.19,318.41,94.64,324Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.23,333.57c-9.55-5.58-25-5.58-34.59,0a16,16,0,0,0-5.72,5.3,15.94,15.94,0,0,0,5.72,5.31c9.55,5.57,25,5.57,34.59,0a15.94,15.94,0,0,0,5.72-5.31A16,16,0,0,0,129.23,333.57Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.37,235.16,108,252.32l-20.92-9.66s-.15,10.51,3.63,19.82c0,0,10.31,6.15,16.29,11.55l-16-6.34s-1.1,10.58,3.3,26.71c1.15,4.22,5.9,12.28,8.9,18.31a69,69,0,0,0,4.66,8.05l.32.49q5.51-3.15,11.43-6.11c2.58-5.42,5.94-18.82,7.16-29.79,4.62-42-27.13-66.05-52.66-74.12C74.07,211.23,82.84,222.22,86.37,235.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.46,236.92c4.42,4.44,7,10.28,9,16.13a84.24,84.24,0,0,1,3.84,18.17,78.59,78.59,0,0,1-4.58,36.46h0a.61.61,0,1,0,1.13.44h0a79.67,79.67,0,0,0,4-37,85.19,85.19,0,0,0-4.16-18.2C111.65,247.12,109,241.28,104.46,236.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,257.18l0,0c-.54.64-9.43,11.21-22.61,31.77l-22,3.53,16.19,2.83-8.69,13.78-21.61,4.46,16.87,2.75s-4.68,16.47-16.76,23.33c-6.67,3.79-9.93,4.37-11.93,2.47-1.4-1.33-1.72-9.23-2.89-16.28s-1.26-18.51,5.39-32.34a43.34,43.34,0,0,1,6.92-10.17C134.9,265.54,165.1,257,180,257.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,264.36c-11.35,5-22.1,11.82-30.54,21.1A60,60,0,0,0,116.06,301a56.83,56.83,0,0,0-4.77,18,.05.05,0,0,0,0,.07.08.08,0,0,0,.07,0,73.45,73.45,0,0,1,5.75-17.54,68,68,0,0,1,10.08-15.4c8.17-9.29,18.68-16.33,29.87-21.63a.06.06,0,1,0-.05-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.22,266.24h0a45.8,45.8,0,0,1,5.52.26,88,88,0,0,1,21.13,5.14c2.53.94,5.06,2,7.55,3.2,1.25.59,2.48,1.22,3.7,1.88A60.87,60.87,0,0,1,103.31,289a38.67,38.67,0,0,1,5.58,7.83c.19.37.4.72.59,1.1h0c.47,1,.89,1.92,1.29,2.85,4.67,10.56,5.07,17.88,4.77,26-.23,6.3-2.37,13.5-3.59,14.68a2.62,2.62,0,0,1-.55.41c-1.8,1.15-4.66.48-10-2.51-10.7-6-14.9-21.14-14.9-21.14l14.88-2.53-19.1-3.81-7.76-12.1,14.27-2.6-19.39-3c-11.77-18.06-19.67-27.33-20.15-27.9,0,0,0,0,0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.74,266.5a88,88,0,0,1,21.13,5.14c2.53.94,5.06,2,7.55,3.2,1.25.59,2.48,1.22,3.7,1.88A60.87,60.87,0,0,1,103.31,289a38.67,38.67,0,0,1,5.58,7.83c.19.37.4.72.59,1.1h0c.47,1,.89,1.92,1.29,2.85,4.67,10.56,5.07,17.88,4.77,26-.23,6.3-2.37,13.5-3.59,14.68a2.62,2.62,0,0,1-.55.41,3.34,3.34,0,0,1-1.18.43c1.32-9.76-3.49-34.54-10.76-44.72-7.57-10.6-25.53-26-50.21-31.28l0,0A44.91,44.91,0,0,1,54.74,266.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.28,342.28a83.83,83.83,0,0,0-1.4-21.61,69.81,69.81,0,0,0-7.17-20.49C98.05,293.81,92.8,288.6,87.2,284a81.25,81.25,0,0,0-18.61-11.15.06.06,0,0,0-.08,0,.07.07,0,0,0,0,.08,106.24,106.24,0,0,1,17.89,12,77.84,77.84,0,0,1,7.87,7.31,47.65,47.65,0,0,1,6.57,8.43,69.11,69.11,0,0,1,7.41,20.13,83.65,83.65,0,0,1,1.88,21.47.07.07,0,0,0,.06.07A.06.06,0,0,0,110.28,342.28Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.35 198.09 49.5 199.97 167.07 131.77 163.93 129.89 46.35 198.09",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.93 129.89 49.5 196.27 49.5 99.17 163.93 32.82 163.93 129.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 62.63 106.8 163.41 112.74 159.99 112.73 59.2 106.8 62.63",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.83 60.91 106.8 62.63 106.8 163.41 103.83 161.69 103.83 60.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,20.7,43.56,95.75V210.24L173,135.19Zm-5.94,111.07L49.5,200V99.17L167.07,31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.07 131.77 163.93 129.89 163.93 32.82 167.07 30.98 167.07 131.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.01 20.7 169.81 18.87 40.37 93.92 43.56 95.75 173.01 20.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.37 93.92 43.56 95.75 43.57 210.24 40.37 208.41 40.37 93.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 66.04 112.72 62.63 112.72 66.05 106.8 69.47 106.8 66.04",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 69.47 103.84 67.76 106.8 66.04 106.8 69.47",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.52,258.4a1.43,1.43,0,0,1,.85-1.18,4.53,4.53,0,0,1,4.09,0,1.44,1.44,0,0,1,.84,1.18l-13.55,73.19h0a1,1,0,0,1-.6.81,3.2,3.2,0,0,1-2.89,0,1,1,0,0,1-.59-.81h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.58,258.4a1.43,1.43,0,0,0-.85-1.18,4.53,4.53,0,0,0-4.09,0,1.44,1.44,0,0,0-.84,1.18l13.55,73.19h0a1,1,0,0,0,.6.81,3.2,3.2,0,0,0,2.89,0,1,1,0,0,0,.59-.81h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.79,261.38a1.43,1.43,0,0,0-.84-1.18,4.47,4.47,0,0,0-4.09,0,1.42,1.42,0,0,0-.85,1.18l.85,84.71h0a1,1,0,0,0,.6.82,3.2,3.2,0,0,0,2.89,0,1,1,0,0,0,.59-.82h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.72,236.75h0c0-7.66-5-15.31-15.14-21.15-20.23-11.69-53-11.69-73.28,0-10.12,5.84-15.14,13.49-15.13,21.15h-.05v4.11h0c.12,7.56,5.19,15.09,15.18,20.86,20.24,11.68,53.05,11.68,73.29,0,10-5.77,15.05-13.3,15.17-20.86h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.26,215.6c-20.24,11.68-20.24,30.62,0,42.31s53.05,11.68,73.29,0,20.23-30.63,0-42.31S370.5,203.91,350.26,215.6Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.25,226.86c6.46,3.73,6.46,9.77,0,13.5s-16.92,3.73-23.37,0-6.46-9.77,0-13.49S391.8,223.14,398.25,226.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28,234.45c-5.62-5.74-8.92-20.06-3.44-24.61h27.9c5.49,4.54,2.19,18.86-3.43,24.6-.05.05-.1.11-.16.16l-.19.19-.51.45-.13.1-.43.33c-.24.17-.48.32-.72.46-4.63,2.67-12.12,2.67-16.75,0h0a8.21,8.21,0,0,1-.73-.47l-.4-.3-.16-.13a5.19,5.19,0,0,1-.49-.43l-.23-.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.32,208c6.37,3.68,6.37,9.64,0,13.31s-16.69,3.68-23.05,0-6.37-9.63,0-13.31S392,204.33,398.32,208Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.81,210.61c3.87,2.24,3.87,5.86,0,8.1a15.55,15.55,0,0,1-14,0c-3.87-2.24-3.87-5.86,0-8.1A15.49,15.49,0,0,1,393.81,210.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,214.45a15.55,15.55,0,0,1,14,0,6.46,6.46,0,0,1,2.32,2.13,6.46,6.46,0,0,1-2.32,2.13,15.55,15.55,0,0,1-14,0,6.46,6.46,0,0,1-2.32-2.13A6.46,6.46,0,0,1,379.78,214.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,216.58a32,32,0,0,0,5.08-6.74c2.34-4.15,2.77-9.7,1.56-10.38s-6.14,4.85-6.14,4.85a30.39,30.39,0,0,0,.52-7.07c-.21-3.69-1.11-7-2.16-7.72s-3.43,4-4.44,7.35-1.62,6.15-1.62,6.15a51.92,51.92,0,0,0-1.82-7.77c-1.23-3.5-2.34-4.29-3.21-3.94s-1.43,2-1.68,6.64a46.48,46.48,0,0,0,.2,6.68s-1.73-1.91-3.66-3.77c-2.12-2-3-2.32-3.64-1.93s-.77,3.56,2.51,9.49a33.25,33.25,0,0,0,6.2,8.16S385.19,219.51,393,216.58Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "461.13 99.07 459.36 100.13 422.9 79.08 424.67 78.02 461.13 99.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.67 78.02 459.36 98.04 459.36 61.72 424.67 41.71 424.67 78.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.54,81l43.17,24.92V59.78L419.54,34.86Zm3.36-40.35,36.46,21.06v38.41l-36.46-21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.9 79.08 424.67 78.02 424.67 41.71 422.89 40.66 422.9 79.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.54 34.86 421.35 33.82 464.51 58.75 462.71 59.78 419.54 34.86",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.51 58.75 462.71 59.78 462.71 105.93 464.51 104.9 464.51 58.75",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.03 76.93 458 95.39 458 86.16 450.01 67.7 445.03 72.31 446.82 80.05 435.78 56.44 426.03 67.7 426.03 76.93",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.33,58.79a5.22,5.22,0,0,1,2.36,4.09c0,1.51-1.06,2.12-2.36,1.37a5.24,5.24,0,0,1-2.37-4.1C443,58.64,444,58,445.33,58.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.62 140.44 400.84 141.5 364.38 120.45 366.16 119.39 402.62 140.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.16 119.39 400.84 139.41 400.84 103.09 366.16 83.08 366.16 119.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,122.38l43.16,24.93V101.15L361,76.23ZM364.38,82l36.46,21V141.5l-36.46-21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.38 120.45 366.16 119.39 366.16 83.08 364.38 82.04 364.38 120.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.03 76.23 362.83 75.2 406 100.12 404.19 101.15 361.03 76.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406 100.12 404.19 101.15 404.19 147.31 406 146.27 406 100.12",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.51 118.3 399.49 136.76 399.49 127.53 391.49 109.07 386.51 113.69 388.3 121.42 377.26 97.81 367.51 109.07 367.51 118.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,100.16a5.22,5.22,0,0,1,2.37,4.09c0,1.51-1.06,2.12-2.37,1.37a5.24,5.24,0,0,1-2.36-4.1C384.45,100,385.51,99.4,386.81,100.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hobbies--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bicicle--inject-136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.52,
    cy: 279.41,
    r: 37.4,
    transform: "translate(-176.62 132.41) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,317.81a38.41,38.41,0,1,1,38.4-38.4A38.45,38.45,0,0,1,71.52,317.81Zm0-74.81a36.41,36.41,0,1,0,36.4,36.41A36.44,36.44,0,0,0,71.52,243Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M96,316.15c-25.44-11.55-47.61-24.39-66.9-38.62-2-1.65-1.46-3.29.31-4.32a7.34,7.34,0,0,1,6.64.13l67,38.69c1.89,1.1,2,2.81.22,3.83A8.69,8.69,0,0,1,96,316.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bicicle--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.38,279.34l-2.83-1.64a.52.52,0,0,0-.51,0L62.1,280a.5.5,0,0,0-.25.44v.25a.5.5,0,0,0,.25.44l2.83,1.64a.52.52,0,0,0,.51,0l3.94-2.28a.5.5,0,0,0,.25-.44v-.25A.5.5,0,0,0,69.38,279.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,281.92a.49.49,0,0,0,.47,0l4.14-2.4a.45.45,0,0,0-.18-.18l-.79-.46-2-1.18a.52.52,0,0,0-.51,0l-.48.28-3.46,2a.5.5,0,0,0-.19.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75,296.05a.43.43,0,0,1-.38-.25L86.86,290a.14.14,0,0,1,0-.06l-4.62-17.34a.41.41,0,1,1,.79-.21l4.61,17.31,2.5,5.76a.41.41,0,0,1-.21.54A.32.32,0,0,1,89.75,296.05Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75,296.05a.43.43,0,0,1-.38-.25L86.86,290a.14.14,0,0,1,0-.06l-4.62-17.34a.41.41,0,1,1,.79-.21l4.61,17.31,2.5,5.76a.41.41,0,0,1-.21.54A.32.32,0,0,1,89.75,296.05Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7,280.77l-.75-.44a10.86,10.86,0,0,0-5.19-1.62h-.13a7.09,7.09,0,0,0-.81,0,8.88,8.88,0,0,0-6.08,3.39l-.08.1-.14.19-.1.14-.11.16a3.62,3.62,0,0,0-.2.33s0,.08-.07.12l-.09.16v0a8.89,8.89,0,0,0-1.07,4.24v1.72c0,7.57,5.3,16.76,11.85,20.54l.76.44a11,11,0,0,0,5.19,1.62h.51l.26,0,.13,0h.07a8.91,8.91,0,0,0,6.21-3.59L102,308l0,0a3.28,3.28,0,0,0,.2-.31,8.87,8.87,0,0,0,1.31-4.65v-1.72C103.56,293.74,98.26,284.55,91.7,280.77Zm-2.6,26.75c-5.53-3.19-10-10.95-10-17.34s4.48-9,10-5.78,10,11,10,17.34S94.63,310.72,89.1,307.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,282.05l-.76-.44c-3.23-1.87-6.17-2.06-8.31-.87l-.17.1,0,0L80,281l-.19.13a3.17,3.17,0,0,0-.35.29l-.17.15a2.57,2.57,0,0,0-.33.33l-.16.18-.15.18-.14.19-.1.14-.11.16a3.62,3.62,0,0,0-.2.33s0,.08-.07.12l-.09.16-.08.17a5.8,5.8,0,0,0-.27.62c0,.12-.09.23-.13.35h0c-.07.22-.14.44-.2.66l-.09.38-.09.44a1.55,1.55,0,0,1,0,.21c0,.12,0,.24-.05.37s0,.27,0,.41V287l0,.36v.15c0,.14,0,.27,0,.41v1.37c0,7.57,5.3,16.76,11.85,20.54l.76.44a10.72,10.72,0,0,0,5.29,1.62h.41l.26,0,.13,0,.26,0,.23,0,.23-.05a2.77,2.77,0,0,0,.41-.12l.18-.05.18-.07.16-.06.34-.16.16-.08,0,0,.06,0,.1-.06c2.11-1.26,3.41-3.89,3.41-7.64v-.87C101.34,295,96,285.83,89.48,282.05Zm-.38,25.47c-5.53-3.19-10-10.95-10-17.34s4.48-9,10-5.78,10,11,10,17.34S94.63,310.72,89.1,307.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,305.89c-1.58,1.88-4.33,2.15-7.45.35-4.91-2.84-8.9-9.74-8.9-15.42,0-2.53.8-4.4,2.12-5.43a7.3,7.3,0,0,0-1.46,4.79c0,5.68,4,12.58,8.91,15.42C92.48,307.17,94.92,307.16,96.55,305.89Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,305.89c-1.58,1.88-4.33,2.15-7.45.35-4.91-2.84-8.9-9.74-8.9-15.42,0-2.53.8-4.4,2.12-5.43a7.3,7.3,0,0,0-1.46,4.79c0,5.68,4,12.58,8.91,15.42C92.48,307.17,94.92,307.16,96.55,305.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,284.4c-5.53-3.19-10-.6-10,5.78s4.48,14.15,10,17.34,10,.61,10-5.78S94.63,287.59,89.1,284.4Zm0,21.84c-4.91-2.84-8.9-9.74-8.9-15.42s4-8,8.9-5.13S98,295.42,98,301.1,94,309.08,89.1,306.24Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,284.4c-5.53-3.19-10-.6-10,5.78s4.48,14.15,10,17.34,10,.61,10-5.78S94.63,287.59,89.1,284.4Zm0,21.84c-4.91-2.84-8.9-9.74-8.9-15.42s4-8,8.9-5.13S98,295.42,98,301.1,94,309.08,89.1,306.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7,298.28l-.06-.31-7.76-2.07,6.93-.62-.1-.27-7,.63,5.7-3.29c0-.08-.1-.16-.14-.24l-5.7,3.29,4-5.72-.18-.22-4,5.66,2.06-7.68-.23-.2-2,7.55v-9l-.14-.08-.13-.08v8.87l-2-9.73-.3-.07,2,9.59-3.8-9.79-.28,0,3.77,9.72L83,285l-.24.13,5.34,9.26-6.56-8.17-.17.23L88,294.65l-7.4-6.56-.09.29L88,295l-7.79-4.5c0,.09,0,.19,0,.28v0l7.93,4.58-7.68-2.06.06.3,7.81,2.09-7,.63c0,.09.06.18.1.27l7.1-.64-5.81,3.36.13.23,5.81-3.35-4.12,5.86.18.22,4.08-5.8-2.11,7.89.22.21L89,296.87v9.28l.13.09.14.07v-9.13l2.05,10,.29.07-2-9.87,3.9,10.05.28,0-3.87-10,5.46,9.45.24-.14-5.46-9.45,6.67,8.29.16-.23L90.23,297l7.46,6.62c0-.1,0-.2.07-.3l-7.56-6.71,7.8,4.51v-.32l-7.93-4.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62,291.82a2.31,2.31,0,0,0-2.41-.2c-.12.08-.28.15-.44.24l-.13.08,0,0h0l-.16.13,0,0-.13.15,0,.06-.11.15a.41.41,0,0,1,0,.09c0,.05,0,.1-.07.16a.61.61,0,0,0-.05.12l-.06.15a1,1,0,0,1,0,.17l0,.14,0,.22a.5.5,0,0,0,0,.12c0,.12,0,.25,0,.37a7.41,7.41,0,0,0,3.34,5.79l.34.17.2.08.14.06.13,0,.19.06h.08l.24,0h0a1.79,1.79,0,0,0,1.09-.25l.49-.28A2.36,2.36,0,0,0,93,297.6,7.38,7.38,0,0,0,89.62,291.82Zm-1,6.41A8.4,8.4,0,0,1,87,295.68a6.59,6.59,0,0,0,.59.36c.87.45.84-.16,1.2.26a2.27,2.27,0,0,1,0,2A.3.3,0,0,1,88.66,298.23Zm1.7-4-.15.06-.51.29a.56.56,0,0,0-.25.26,4.64,4.64,0,0,1-.89-2.5,5.64,5.64,0,0,1,2.18,1.7.36.36,0,0,1,0,.09A2.13,2.13,0,0,0,90.36,294.28Zm-2.54-.44c.28,1,.71,1.16.73,1.49-.65-.11-1.72-.75-1.79-1.38a2.5,2.5,0,0,1,.58-1.69C87.61,292.38,87.6,293,87.82,293.84Zm1.89,5.29c-.35-.32,0-.63.22-1.29a1.75,1.75,0,0,0,0-.95c.68.53,1.71,1.95,1.44,2.37l0,0A2.24,2.24,0,0,1,89.71,299.13Zm1.63-2.2c-.73-1-1-.63-1.19-1.15a.68.68,0,0,1,.24-.7.86.86,0,0,1,1,.36,6.43,6.43,0,0,1,.57,2.49C91.83,297.67,91.62,297.3,91.34,296.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62,291.82a2.31,2.31,0,0,0-2.41-.2c-.12.08-.28.15-.44.24l-.13.08,0,0h0l-.16.13,0,0-.13.15,0,.06-.11.15a.41.41,0,0,1,0,.09c0,.05,0,.1-.07.16a.61.61,0,0,0-.05.12l-.06.15a1,1,0,0,1,0,.17l0,.14,0,.22a.5.5,0,0,0,0,.12c0,.12,0,.25,0,.37a7.41,7.41,0,0,0,3.34,5.79l.34.17.2.08.14.06.13,0,.19.06h.08l.24,0h0a1.79,1.79,0,0,0,1.09-.25l.49-.28A2.36,2.36,0,0,0,93,297.6,7.38,7.38,0,0,0,89.62,291.82Zm-1,6.41A8.4,8.4,0,0,1,87,295.68a6.59,6.59,0,0,0,.59.36c.87.45.84-.16,1.2.26a2.27,2.27,0,0,1,0,2A.3.3,0,0,1,88.66,298.23Zm1.7-4-.15.06-.51.29a.56.56,0,0,0-.25.26,4.64,4.64,0,0,1-.89-2.5,5.64,5.64,0,0,1,2.18,1.7.36.36,0,0,1,0,.09A2.13,2.13,0,0,0,90.36,294.28Zm-2.54-.44c.28,1,.71,1.16.73,1.49-.65-.11-1.72-.75-1.79-1.38a2.5,2.5,0,0,1,.58-1.69C87.61,292.38,87.6,293,87.82,293.84Zm1.89,5.29c-.35-.32,0-.63.22-1.29a1.75,1.75,0,0,0,0-.95c.68.53,1.71,1.95,1.44,2.37l0,0A2.24,2.24,0,0,1,89.71,299.13Zm1.63-2.2c-.73-1-1-.63-1.19-1.15a.68.68,0,0,1,.24-.7.86.86,0,0,1,1,.36,6.43,6.43,0,0,1,.57,2.49C91.83,297.67,91.62,297.3,91.34,296.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,292.11c-1.84-1.07-3.34-.2-3.34,1.92a7.41,7.41,0,0,0,3.34,5.79c1.85,1.06,3.34.2,3.34-1.93A7.35,7.35,0,0,0,89.1,292.11Zm-.82.22a5,5,0,0,1,2.46,1.76c.22.46-.36.29-.89.48s-.36.89-.76.72C88.51,295.05,87.62,292.32,88.28,292.33Zm-1-.1c.34.06.3.73.54,1.61.31,1.11.8,1.18.73,1.6-.1.61-2.2-.3-2.3-1.2S86.94,292.17,87.28,292.23Zm.87,6.29a7.63,7.63,0,0,1-1.82-3c0-.42.55.16,1.23.52.87.45.84-.16,1.2.26C89.28,296.92,88.88,299.08,88.15,298.52Zm3.21.74c-.34.55-1.81.47-2.16.16s0-.63.22-1.29c.22-.84-.27-1.29,0-1.44S91.71,298.71,91.36,299.26Zm-.53-2c-.72-1-1-.64-1.19-1.15-.26-.76,1.29-1.53,1.8-.63a5.4,5.4,0,0,1,.49,3.09C91.72,298.75,91.4,298,90.83,297.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,297.14c.57.33,1,.06,1-.59a2.25,2.25,0,0,0-1-1.77c-.56-.32-1-.06-1,.59A2.28,2.28,0,0,0,89.1,297.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.33,255.72l-.76-.44a10.84,10.84,0,0,0-5.19-1.61h-.13a7,7,0,0,0-.81.05,8.84,8.84,0,0,0-6.07,3.39l-.09.1a1.33,1.33,0,0,0-.14.19,1.13,1.13,0,0,0-.1.13l-.11.17a3.45,3.45,0,0,0-.2.32.75.75,0,0,1-.07.12l-.09.17h0a8.85,8.85,0,0,0-1.08,4.25v.35c0,.16,0,.33,0,.49v.88c0,7.56,5.3,16.76,11.86,20.54l.75.44a10.84,10.84,0,0,0,5.19,1.61h.51l.26,0h.2a8.88,8.88,0,0,0,6.21-3.6l.18-.25,0,0a3.28,3.28,0,0,0,.2-.31A8.83,8.83,0,0,0,60.18,278v-1.73C60.18,268.7,54.88,259.5,48.33,255.72Zm-2.61,26.76c-5.53-3.2-10-11-10-17.34s4.48-9,10-5.78,10,10.95,10,17.34S51.25,285.67,45.72,282.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,257l-.75-.44c-3.24-1.87-6.18-2.07-8.32-.87l-.17.1,0,0-.19.13-.19.13c-.12.09-.24.18-.35.28a1.29,1.29,0,0,0-.17.16,2.57,2.57,0,0,0-.33.33.93.93,0,0,0-.16.18l-.15.18a1.33,1.33,0,0,0-.14.19,1.13,1.13,0,0,0-.1.13l-.11.17a3.45,3.45,0,0,0-.2.32.75.75,0,0,1-.07.12l-.09.17-.08.16a6,6,0,0,0-.27.63c0,.11-.09.23-.13.34v0c-.07.21-.14.43-.2.66l-.09.37-.09.44,0,.21c0,.12,0,.25-.06.37s0,.27,0,.42V262l0,.36v.15c0,.13,0,.27,0,.41s0,.33,0,.49v.88c0,7.56,5.3,16.76,11.86,20.54l.75.44a10.81,10.81,0,0,0,5.3,1.61h.4l.26,0h.13l.27,0,.23,0,.22-.05.41-.11.18-.05.18-.07.16-.07a3.49,3.49,0,0,0,.34-.15l.16-.09,0,0,.06,0a.6.6,0,0,0,.11-.06c2.1-1.25,3.4-3.89,3.4-7.63v-.87C58,270,52.65,260.79,46.1,257Zm-.38,25.47c-5.53-3.2-10-11-10-17.34s4.48-9,10-5.78,10,10.95,10,17.34S51.25,285.67,45.72,282.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.17,280.84c-1.58,1.88-4.33,2.15-7.45.35-4.91-2.83-8.9-9.73-8.9-15.41,0-2.54.8-4.4,2.12-5.43a7.28,7.28,0,0,0-1.45,4.79c0,5.67,4,12.57,8.9,15.41C49.1,282.12,51.54,282.12,53.17,280.84Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.17,280.84c-1.58,1.88-4.33,2.15-7.45.35-4.91-2.83-8.9-9.73-8.9-15.41,0-2.54.8-4.4,2.12-5.43a7.28,7.28,0,0,0-1.45,4.79c0,5.67,4,12.57,8.9,15.41C49.1,282.12,51.54,282.12,53.17,280.84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,259.36c-5.53-3.2-10-.61-10,5.78s4.48,14.15,10,17.34,10,.6,10-5.78S51.25,262.55,45.72,259.36Zm0,21.83c-4.91-2.83-8.9-9.74-8.9-15.41s4-8,8.9-5.14,8.9,9.74,8.9,15.42S50.64,284,45.72,281.19Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,259.36c-5.53-3.2-10-.61-10,5.78s4.48,14.15,10,17.34,10,.6,10-5.78S51.25,262.55,45.72,259.36Zm0,21.83c-4.91-2.83-8.9-9.74-8.9-15.41s4-8,8.9-5.14,8.9,9.74,8.9,15.42S50.64,284,45.72,281.19Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32,273.23l-.06-.3-7.75-2.08,6.92-.62c0-.08-.07-.17-.1-.26l-7,.62L52,267.3c-.05-.08-.1-.15-.14-.23l-5.7,3.29,4-5.72-.18-.23-4,5.66,2-7.67-.23-.21-2,7.55v-9l-.14-.08-.13-.07v8.86l-2-9.72-.3-.08,2,9.59-3.79-9.79-.29,0L45,269.18l-5.34-9.26-.24.14,5.34,9.25-6.56-8.16c-.06.07-.11.15-.17.23l6.62,8.23L37.2,263l-.09.29L44.62,270l-7.79-4.5c0,.1,0,.19,0,.29v0l7.93,4.57-7.68-2.06.06.3,7.81,2.1-7,.63c0,.08.06.17.1.26l7.1-.63-5.81,3.35.13.24,5.81-3.36-4.11,5.86c0,.08.11.15.17.23l4.08-5.8-2.11,7.88.23.21,2.08-7.76v9.28l.13.08.14.08v-9.13l2,10,.29.08-2-9.87,3.9,10,.28,0-3.87-10L52,281.85l.24-.14-5.46-9.45,6.67,8.29.16-.23L46.85,272l7.46,6.61c0-.1,0-.2.07-.3l-7.55-6.7,7.79,4.5v-.32l-7.93-4.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.24,266.77a2.31,2.31,0,0,0-2.41-.2c-.12.08-.28.15-.44.25l-.13.08h0a1.07,1.07,0,0,0-.16.14l0,0c0,.05-.09.09-.13.15l0,.06a1,1,0,0,0-.11.15.41.41,0,0,1,0,.09l-.07.15s0,.09-.05.13a.88.88,0,0,0,0,.15s0,.11-.05.16l0,.15,0,.22s0,.08,0,.12,0,.24,0,.37a7.37,7.37,0,0,0,3.33,5.78l.34.18.2.08.14.05.13,0,.19.05h.08l.24,0h0a1.72,1.72,0,0,0,1.09-.26c.16-.09.31-.16.49-.27a2.34,2.34,0,0,0,.95-2.14A7.41,7.41,0,0,0,46.24,266.77Zm-1,6.42a8.05,8.05,0,0,1-1.69-2.55c.17.11.37.24.58.35.87.45.85-.16,1.2.27a2.27,2.27,0,0,1,0,2Zm1.69-4a.46.46,0,0,0-.14.07l-.52.29a.66.66,0,0,0-.25.25,4.61,4.61,0,0,1-.89-2.49A5.53,5.53,0,0,1,47.36,269a.69.69,0,0,1,0,.1A2.1,2.1,0,0,0,47,269.23Zm-2.54-.44c.28,1,.71,1.16.73,1.49-.65-.1-1.72-.74-1.79-1.37a2.53,2.53,0,0,1,.58-1.7C44.23,267.33,44.22,268,44.44,268.79Zm1.89,5.29c-.35-.32,0-.63.22-1.28a1.79,1.79,0,0,0,0-1c.68.54,1.71,2,1.44,2.38l0,0A2.18,2.18,0,0,1,46.33,274.08ZM48,271.89c-.72-1-1-.64-1.19-1.16A.66.66,0,0,1,47,270a.85.85,0,0,1,1.05.35,6.47,6.47,0,0,1,.57,2.49C48.45,272.62,48.24,272.25,48,271.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.24,266.77a2.31,2.31,0,0,0-2.41-.2c-.12.08-.28.15-.44.25l-.13.08h0a1.07,1.07,0,0,0-.16.14l0,0c0,.05-.09.09-.13.15l0,.06a1,1,0,0,0-.11.15.41.41,0,0,1,0,.09l-.07.15s0,.09-.05.13a.88.88,0,0,0,0,.15s0,.11-.05.16l0,.15,0,.22s0,.08,0,.12,0,.24,0,.37a7.37,7.37,0,0,0,3.33,5.78l.34.18.2.08.14.05.13,0,.19.05h.08l.24,0h0a1.72,1.72,0,0,0,1.09-.26c.16-.09.31-.16.49-.27a2.34,2.34,0,0,0,.95-2.14A7.41,7.41,0,0,0,46.24,266.77Zm-1,6.42a8.05,8.05,0,0,1-1.69-2.55c.17.11.37.24.58.35.87.45.85-.16,1.2.27a2.27,2.27,0,0,1,0,2Zm1.69-4a.46.46,0,0,0-.14.07l-.52.29a.66.66,0,0,0-.25.25,4.61,4.61,0,0,1-.89-2.49A5.53,5.53,0,0,1,47.36,269a.69.69,0,0,1,0,.1A2.1,2.1,0,0,0,47,269.23Zm-2.54-.44c.28,1,.71,1.16.73,1.49-.65-.1-1.72-.74-1.79-1.37a2.53,2.53,0,0,1,.58-1.7C44.23,267.33,44.22,268,44.44,268.79Zm1.89,5.29c-.35-.32,0-.63.22-1.28a1.79,1.79,0,0,0,0-1c.68.54,1.71,2,1.44,2.38l0,0A2.18,2.18,0,0,1,46.33,274.08ZM48,271.89c-.72-1-1-.64-1.19-1.16A.66.66,0,0,1,47,270a.85.85,0,0,1,1.05.35,6.47,6.47,0,0,1,.57,2.49C48.45,272.62,48.24,272.25,48,271.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,267.06c-1.84-1.06-3.33-.2-3.33,1.93a7.37,7.37,0,0,0,3.33,5.78c1.85,1.06,3.34.2,3.34-1.93A7.38,7.38,0,0,0,45.72,267.06Zm-.82.23A5.06,5.06,0,0,1,47.36,269c.22.46-.36.29-.89.48s-.36.89-.75.73C45.13,270,44.24,267.28,44.9,267.29Zm-1-.1c.34.06.3.72.54,1.6.31,1.11.8,1.19.73,1.6-.1.61-2.2-.3-2.3-1.2S43.56,267.13,43.9,267.19Zm.87,6.28a7.67,7.67,0,0,1-1.82-3c0-.42.55.16,1.23.51.87.45.85-.16,1.2.27C45.9,271.87,45.5,274,44.77,273.47Zm3.21.75c-.34.54-1.81.47-2.16.15s0-.63.22-1.29c.22-.83-.27-1.28,0-1.44S48.33,273.67,48,274.22Zm-.53-2c-.72-1-1-.64-1.19-1.16-.26-.75,1.29-1.53,1.8-.63a5.41,5.41,0,0,1,.49,3.09C48.34,273.71,48,272.94,47.45,272.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,272.1c.57.32,1,.06,1-.59a2.24,2.24,0,0,0-1-1.77c-.56-.33-1-.06-1,.59A2.28,2.28,0,0,0,45.72,272.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,272.26a.42.42,0,0,0-.58-.09l-1.05.79-.19-.76L63.7,285.3l-.36.2L46,270.6a.4.4,0,0,0-.58,0,.41.41,0,0,0,.05.57l18,15.45.14.1a.76.76,0,0,0,.37.1.79.79,0,0,0,.48-.19h0l17.1-12.85,1.33-1A.41.41,0,0,0,83,272.26Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,277.33a23.11,23.11,0,0,1-5-.57h0l-16.2-5.45a.41.41,0,0,1,0-.78l14.46-3.86c.22-.06.48,1.32.26,1.37l-11.58,3L62,275.5c4.94,1.11,9.57.67,12.89-1.48,2.87-1.86,4.73-4.83,5.54-8.84,0-.23.38-.05.6,0a.41.41,0,0,1,.32.49c-.85,4.23-2.84,7.39-5.9,9.37A15.89,15.89,0,0,1,66.83,277.33Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.79,286.82a.41.41,0,0,1-.4-.33l-6.71-34.91a.41.41,0,0,1,.33-.48c.22,0,.91,0,1,.19l6.7,34.91c0,.22-.57.57-.79.61Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,279.5a.42.42,0,0,1-.38-.27l-1.18-3.18a.4.4,0,0,1,.25-.52c.21-.08.8-.24.88,0l1.18,3.18c.07.21-.39.71-.6.79Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,296.45a.44.44,0,0,1-.31-.14l-4-4.57a.56.56,0,0,1-.09-.17l-4.62-17.34a.42.42,0,0,1,.3-.5.41.41,0,0,1,.5.29l4.59,17.25,4,4.5a.41.41,0,0,1,0,.58A.38.38,0,0,1,89.1,296.45Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.89,273.4l-1-13c0-.3,1.08-.38,1.1-.08l1,13C82,273.63,80.91,273.69,80.89,273.4Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.69,270.67s0,.95,0,1.48-1,1.23-.67,2.2.7,2.47.7,2.47a.58.58,0,0,0,.77-.32l-.4-1.49a1.13,1.13,0,0,1,.41-1.18l.17-.12a.57.57,0,0,1,.9.31l.43,1.61s.62.12.73-.45c0,0-.54-2.14-.78-2.92-.19-.62-1.11-.36-1.16-1.17l-.07-.91C81.78,270.59,80.92,271,80.69,270.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,260.31c0-.3-1.12-.22-1.1.08l.29,3.84a2.68,2.68,0,0,0,1.13.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.39,282.21A2.31,2.31,0,0,0,62,282l-.44.24-.13.09h0l-.16.13,0,0a.86.86,0,0,0-.13.14l0,.06-.1.15,0,.09s-.05.1-.08.16l0,.12-.06.16s0,.1,0,.16l0,.14a.83.83,0,0,0,0,.22.51.51,0,0,0,0,.13c0,.11,0,.24,0,.37a7.41,7.41,0,0,0,3.34,5.78l.34.17a.84.84,0,0,0,.2.08l.14.06.13,0,.19.05h.07l.24,0h0a1.67,1.67,0,0,0,1.09-.25c.16-.1.3-.17.49-.27a2.38,2.38,0,0,0,.94-2.14A7.37,7.37,0,0,0,64.39,282.21Zm-1,6.41a8.16,8.16,0,0,1-1.69-2.55,6.59,6.59,0,0,0,.59.36c.86.45.84-.16,1.2.26a2.27,2.27,0,0,1,0,2Zm1.69-3.95-.14.06-.51.29a.72.72,0,0,0-.26.26,4.71,4.71,0,0,1-.88-2.5,5.71,5.71,0,0,1,2.18,1.7.19.19,0,0,1,0,.09A2.53,2.53,0,0,0,65.12,284.67Zm-2.53-.44c.28,1,.7,1.16.73,1.49-.66-.11-1.72-.75-1.79-1.38a2.54,2.54,0,0,1,.57-1.69C62.38,282.77,62.36,283.4,62.59,284.23Zm1.89,5.29c-.35-.32,0-.63.21-1.29a1.77,1.77,0,0,0,0-1c.68.53,1.7,2,1.44,2.37l0,0A2.23,2.23,0,0,1,64.48,289.52Zm1.63-2.2c-.73-1-1-.63-1.19-1.15a.68.68,0,0,1,.23-.7.88.88,0,0,1,1.06.36,6.24,6.24,0,0,1,.56,2.49C66.6,288.06,66.38,287.69,66.11,287.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.39,282.21A2.31,2.31,0,0,0,62,282l-.44.24-.13.09h0l-.16.13,0,0a.86.86,0,0,0-.13.14l0,.06-.1.15,0,.09s-.05.1-.08.16l0,.12-.06.16s0,.1,0,.16l0,.14a.83.83,0,0,0,0,.22.51.51,0,0,0,0,.13c0,.11,0,.24,0,.37a7.41,7.41,0,0,0,3.34,5.78l.34.17a.84.84,0,0,0,.2.08l.14.06.13,0,.19.05h.07l.24,0h0a1.67,1.67,0,0,0,1.09-.25c.16-.1.3-.17.49-.27a2.38,2.38,0,0,0,.94-2.14A7.37,7.37,0,0,0,64.39,282.21Zm-1,6.41a8.16,8.16,0,0,1-1.69-2.55,6.59,6.59,0,0,0,.59.36c.86.45.84-.16,1.2.26a2.27,2.27,0,0,1,0,2Zm1.69-3.95-.14.06-.51.29a.72.72,0,0,0-.26.26,4.71,4.71,0,0,1-.88-2.5,5.71,5.71,0,0,1,2.18,1.7.19.19,0,0,1,0,.09A2.53,2.53,0,0,0,65.12,284.67Zm-2.53-.44c.28,1,.7,1.16.73,1.49-.66-.11-1.72-.75-1.79-1.38a2.54,2.54,0,0,1,.57-1.69C62.38,282.77,62.36,283.4,62.59,284.23Zm1.89,5.29c-.35-.32,0-.63.21-1.29a1.77,1.77,0,0,0,0-1c.68.53,1.7,2,1.44,2.37l0,0A2.23,2.23,0,0,1,64.48,289.52Zm1.63-2.2c-.73-1-1-.63-1.19-1.15a.68.68,0,0,1,.23-.7.88.88,0,0,1,1.06.36,6.24,6.24,0,0,1,.56,2.49C66.6,288.06,66.38,287.69,66.11,287.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.87,282.5c-1.84-1.06-3.34-.2-3.34,1.93a7.41,7.41,0,0,0,3.34,5.78c1.84,1.06,3.34.2,3.34-1.93A7.38,7.38,0,0,0,63.87,282.5Zm-.83.23a5,5,0,0,1,2.47,1.75c.22.46-.36.29-.89.48-.68.24-.36.89-.76.73C63.28,285.44,62.39,282.71,63,282.73Zm-1-.11c.34.06.3.73.54,1.61.31,1.11.8,1.18.73,1.6-.1.61-2.2-.3-2.31-1.2S61.71,282.56,62.05,282.62Zm.87,6.29a7.55,7.55,0,0,1-1.82-3c0-.43.54.15,1.23.51.86.45.84-.16,1.2.26C64.05,287.31,63.64,289.47,62.92,288.91Zm3.21.74c-.35.55-1.82.48-2.16.16s0-.63.22-1.29c.22-.83-.28-1.28,0-1.44S66.48,289.1,66.13,289.65Zm-.53-2c-.73-1-1-.63-1.19-1.15-.26-.76,1.29-1.53,1.8-.63a5.39,5.39,0,0,1,.48,3.09C66.49,289.14,66.17,288.37,65.6,287.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.87,287.53c.56.33,1,.06,1-.59a2.28,2.28,0,0,0-1-1.77c-.56-.32-1-.06-1,.59A2.26,2.26,0,0,0,63.87,287.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,291.74a.27.27,0,0,1-.12,0,.28.28,0,0,1-.13-.37l2.26-4.57,1.18-.68a.28.28,0,0,1,.38.1.27.27,0,0,1-.1.37l-1,.61-2.19,4.42A.27.27,0,0,1,60.5,291.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,292.57l-2.83-1.63a.47.47,0,0,0-.51,0l-3.94,2.27a.51.51,0,0,0-.26.44v.25a.51.51,0,0,0,.26.44L58.05,296a.52.52,0,0,0,.51,0l3.94-2.28a.5.5,0,0,0,.25-.44V293A.5.5,0,0,0,62.5,292.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.07,295.15a.44.44,0,0,0,.47,0l4.14-2.4a.45.45,0,0,0-.18-.18l-.79-.46-2-1.18a.49.49,0,0,0-.51,0l-.48.27-3.46,2a.58.58,0,0,0-.19.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.08,257.85a25.06,25.06,0,0,0-2.77-3.31s-5-6.75-10.58-3.54a3.7,3.7,0,0,0-1.93,2.74,4.73,4.73,0,0,0,0,1.21,2.83,2.83,0,0,0,.69,1.69c.73,1,2.8,1.84,5.28,2.47l.54.13c.88.2,1.77.37,2.66.56s1.77.35,2.64.59c.36.09.71.2,1.06.32l.42.18a1.36,1.36,0,0,0,.54.23,1.26,1.26,0,0,0,.38,0,1.31,1.31,0,0,0,.34-.09.92.92,0,0,0,.27-.16,2,2,0,0,0,.68-1A2.39,2.39,0,0,0,69.08,257.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.73,251c-1.69,1-2.61,2.77-1.28,4.6.73,1,2.8,1.84,5.28,2.47s6.72,1.19,7.77,2.05,2.55-.69,1.58-2.27a25.06,25.06,0,0,0-2.77-3.31S61.29,247.79,55.73,251Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,244.73l-.87-1.5,3.69-2.13h0a.42.42,0,0,1,.44,0,1.34,1.34,0,0,1,.61,1.06.42.42,0,0,1-.17.39h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.06,244.33c0,.4-.27.56-.61.36a1.37,1.37,0,0,1-.62-1.07c0-.39.28-.55.62-.35A1.34,1.34,0,0,1,92.06,244.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.65,244.2a.25.25,0,0,1,0,.16l-.1.06-5.31,3.06c-1,.6-1.39,2-1.58,3.53l0,.32c-.1.89-.19,1.7-.29,2.5-.14,1.25-.28,2.46-.44,3.84-.23,2.07-1.08,2.88-2.9,3.93l-.42-.73c1.69-1,2.29-1.59,2.48-3.29.16-1.38.3-2.59.44-3.85.08-.68.16-1.37.24-2.11,0-.13,0-.25,0-.38l.09-.7c.24-1.59.7-3.07,1.94-3.79l.09-.05,5.32-3.07a.24.24,0,0,1,.17,0A.68.68,0,0,1,91.65,244.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.81,261.48a.88.88,0,0,0-.51-.69l-2.15-1.24-2.23,1.28v1.29l2.15,1.24a2.52,2.52,0,0,0,2.3,0,.73.73,0,0,0,.44-.64S82.82,261.71,82.81,261.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.15,259.55l2.15,1.24c.65.38.68,1,.07,1.33a2.59,2.59,0,0,1-2.3,0l-2.15-1.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.26,262.44a.22.22,0,0,1-.06.17l-.06,0,0,0a3.73,3.73,0,0,1-1.64.57,1,1,0,0,1-.49-.11.78.78,0,0,1-.18-.11,2,2,0,0,1-.6-1.4c-.15-1.21-.3-2.26-.44-3.34-.09-.69-.19-1.39-.29-2.16-.15-1.12-.36-1.75-.63-1.88s-.39,0-.57.13l-5.84,3.38L68,257l5.84-3.38a1.42,1.42,0,0,1,1.37-.16c.71.35.94,1.42,1.09,2.53.1.76.19,1.47.29,2.15.14,1.09.28,2.14.44,3.36.08.65.23.81.31.85s.76-.13,1.21-.37l.11-.05.1-.06h0a.19.19,0,0,1,.19,0A.69.69,0,0,1,79.26,262.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.07,259.51,65.2,258l3.68-2.12h0a.44.44,0,0,1,.45,0,1.34,1.34,0,0,1,.61,1.06.44.44,0,0,1-.17.39h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.25,259.11c0,.4-.28.55-.62.36A1.36,1.36,0,0,1,65,258.4c0-.39.27-.55.61-.35A1.35,1.35,0,0,1,66.25,259.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 183.12,
    cy: 185.38,
    r: 2.36,
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.17 256.46 100.41 255.81 161.86 184.88 183.12 184.88 183.12 185.88 162.32 185.88 101.17 256.46",
    style: {
      fill: "#603FEF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pet--inject-136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.38,
    cy: 155.87,
    r: 37.4,
    transform: "translate(-33.96 20.11) rotate(-13.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,194.27a38.4,38.4,0,1,1,38.4-38.4A38.45,38.45,0,0,1,69.38,194.27Zm0-74.8a36.4,36.4,0,1,0,36.4,36.4A36.44,36.44,0,0,0,69.38,119.47Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M53.25,165.35h-.71a22.71,22.71,0,0,0-8.36,1.43c-2.22.91-6.87,3.63-5.28,6.67,1.35,2.6,5.1,3.78,7.66,4.65s5.13,1.83,7.72,2.87a25.6,25.6,0,0,0,6.46,1.55c2.15.25,4.66-.11,6.7.63,6.84,2.48,14.21,4.61,21.39,1.74a9.48,9.48,0,0,0,4.25-3.54c1.06-2,.29-4-1-5.63-2.67-3.55-8.14-5.42-12.21-6.53a126.94,126.94,0,0,0-17.15-2.93c-1.6-.2-3-.23-4.57-.53A27.41,27.41,0,0,0,53.25,165.35Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dog--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.25,165.5a5.85,5.85,0,0,0-1-.44,3.2,3.2,0,0,0-2.83.07,3.74,3.74,0,0,0-1.1,2.67c0,.39.18.66.27,1a2.29,2.29,0,0,0,.07.36c.07.18.21.34.29.52a1.77,1.77,0,0,1,.15.79,7.25,7.25,0,0,0,.11,1.74,2.25,2.25,0,0,0,.87,1.32,5.29,5.29,0,0,0,.67.46c.33.18.68.34,1,.52a13.16,13.16,0,0,0,2.35,1.09,4.15,4.15,0,0,0,.48.11,2.49,2.49,0,0,0,.9,0c.22,0,.35-.27.54-.28.34,0,.6.12.93-.06a.76.76,0,0,0,.37-.76c.53-.16.61-.93.36-1.34a3.26,3.26,0,0,0-1.08-1c-.46-.28-1.19-.53-1.36-1.09a1.45,1.45,0,0,0-.34-.73c-.25-.26-.65-.57-.72-.93-.1-.51.27-1,.22-1.51s-.33-.59-.43-.94,0-.57-.08-.84A1.38,1.38,0,0,0,69.25,165.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1,162.87c-.13.24-.56.54-.53.84s1.1.73,1.37,1.08a1.84,1.84,0,0,1-.31,2.45c-.55.59-.8.71-.59,1.51a3,3,0,0,1-2.74,3.81c.06.54-.33.75-.81.93a3.7,3.7,0,0,1-1.61.24c-.26,0-.46-.24-.7-.28s-.42.19-.74.36a2.53,2.53,0,0,1-2.33-.11c-.38-.16-.31,0-.75,0a1.94,1.94,0,0,1-1.16-.25c-.31-.17-.55-.52-.85-.67s-.81-.13-1.2-.34a3,3,0,0,1-1.71-2.6c-.95.92-2.58-4-1.26-3.59-.93-.33-.73-2.4-.57-3.07.29-1.12,1-2,2.26-1.78a3,3,0,0,1,1.46-2.79,3,3,0,0,1,1.84-.55c.3,0,.66.16,1,.14s.21-.16.48-.4a1.88,1.88,0,0,1,.77-.28,2.38,2.38,0,0,1,1.57.23c.5.29.72.85,1.35.86,1.12,0,2.33-.85,3.39-.13.62.42.52,1,.85,1.53s1,.71,1.4,1.23A1.7,1.7,0,0,1,76.1,162.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6,159a1.79,1.79,0,0,0,.2-.26,4.4,4.4,0,0,0,.48-1.67L51,153a5.2,5.2,0,0,0,.11-1.8,1.87,1.87,0,0,0-1-1.44,1.15,1.15,0,0,0-1.52.55c0-.59-.1-1.18-.19-1.76a1.4,1.4,0,0,0-.33-.85c-.43-.42-1.17-.16-1.61.26.21-1.44,1.09-2.78,1-4.23a1.3,1.3,0,0,0-.24-.79,1.63,1.63,0,0,0-1.36-.4l1.44-.78a3.4,3.4,0,0,0,1-.66,1.22,1.22,0,0,0,.34-1.07.74.74,0,0,0-.89-.55,3.53,3.53,0,0,1,.82-.48c.27-.17.51-.49.39-.78a.8.8,0,0,0-.26-.29,3,3,0,0,0-2.54-.26A7.4,7.4,0,0,0,43.87,139c.14-.22-.11-.51-.36-.52a1,1,0,0,0-.67.33,9.09,9.09,0,0,0-2.61,4.87.56.56,0,0,0-.8,0,1.32,1.32,0,0,0-.36.81,7.16,7.16,0,0,0,0,2.69,5.36,5.36,0,0,0,1,2.1.94.94,0,0,0-1.64.38c-.17,1.16.76,1.87,1.55,2.51-.17.15-.42.16-.57.41a1.28,1.28,0,0,0,0,1.16,5.39,5.39,0,0,0,1.94,1.67c-1.61,1.07,2.22,2.68,3,3.15a2.76,2.76,0,0,1,1.11,1.11,7,7,0,0,1,.43.92c.08.2.15.62.35.73.66.36,1.95-1.23,2.4-1.59A11.83,11.83,0,0,0,49.6,159Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.67,164.16l.43-.09C75.09,163.85,75,163.78,74.67,164.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.28,167.79a2.42,2.42,0,0,0,.22-1.4c0-.34-.37-.83-.19-1.15s.35-.23.51-.37a1.3,1.3,0,0,0,.41-.79,6.2,6.2,0,0,0-.09-1.05c0-.46.29-.66.48-1a3.8,3.8,0,0,0,.41-1.26c.1-.69-.42-1.13-.07-1.77a1.58,1.58,0,0,0,.2-.65c0-.27.28-.44.31-.7a1.21,1.21,0,0,0-.2-1.08c-.85-.74-1.91.08-2.6.58-1.08.78-2.5.85-3.6,1.58a3.53,3.53,0,0,1-1.58.56,4.94,4.94,0,0,1-1.22,0,9.35,9.35,0,0,0-.11,2.3,3.18,3.18,0,0,0,1,2,.7.7,0,0,1,.3.38l-.36.08a3.57,3.57,0,0,1-.09.62,2,2,0,0,0,.22,1.59.89.89,0,0,1,.07,1.35,2.13,2.13,0,0,0,.11,2.14,1.76,1.76,0,0,1,.38.71,3.36,3.36,0,0,1-.13.76c0,.39.18.66.27,1,0,.12,0,.24.07.36s.21.34.29.52a1.63,1.63,0,0,1,.16.78,7.29,7.29,0,0,0,.1,1.75,2.29,2.29,0,0,0,.88,1.32,6,6,0,0,0,.66.46c.34.18.68.34,1,.52a13.16,13.16,0,0,0,2.35,1.09,4.31,4.31,0,0,0,.49.11,2.47,2.47,0,0,0,.9,0c.22,0,.35-.27.53-.28.34,0,.61.12.94-.06a.77.77,0,0,0,.36-.76c.54-.16.62-.93.36-1.34a3.17,3.17,0,0,0-1.08-1c-.46-.28-1.18-.53-1.36-1.09a1.4,1.4,0,0,0-.33-.73c-.25-.26-.66-.57-.73-.93s.28-1,.22-1.51a.91.91,0,0,0-.09-.36c-.07-.16-.23-.25-.29-.42-.12-.33.28-.71.28-1.06a1.82,1.82,0,0,0-.23-.75,2.91,2.91,0,0,1-.28-.66A1,1,0,0,1,81.28,167.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.65,169.15a5.76,5.76,0,0,0-1-.44,3.23,3.23,0,0,0-2.83.08,3.69,3.69,0,0,0-1.11,2.66c0,.4.18.66.27,1,0,.12,0,.24.07.36s.21.33.29.51a1.7,1.7,0,0,1,.16.79,7.29,7.29,0,0,0,.1,1.75,2.29,2.29,0,0,0,.88,1.31,4.48,4.48,0,0,0,.67.47l1,.52a13.16,13.16,0,0,0,2.35,1.09l.49.11a2.47,2.47,0,0,0,.9,0c.22,0,.35-.27.53-.28.34,0,.61.12.94-.06a.77.77,0,0,0,.36-.76.93.93,0,0,0,.36-1.34A3.17,3.17,0,0,0,66,176c-.46-.29-1.18-.53-1.36-1.09a1.4,1.4,0,0,0-.33-.73c-.25-.26-.66-.57-.73-.94s.28-1,.22-1.5-.32-.59-.43-1,0-.56-.08-.83A1.39,1.39,0,0,0,62.65,169.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.93,146.76c-.35.62-.7,1.23-1.5,1.32-1,.11-2.6-.09-3,1.08a4.1,4.1,0,0,1-.32,1.1c-.38.56-.93.59-1.54.66-1.15.13-2.74.43-3,1.7s-1,1.1-2,1.59a4.11,4.11,0,0,0-1.63,1.25c-.58.8-.19,1.17-.32,2-.1.66-1,1.19-1.44,1.65a5.8,5.8,0,0,0-1.56,2.54,1.77,1.77,0,0,0,0,1.07c.15.32.5.49.65.81.34.76-.23,1.4-.38,2.11a1.76,1.76,0,0,0,.41,1.81c.54.4,1.16.31,1.49,1s.1,1.32.3,1.94a2.21,2.21,0,0,0,1.35,1.46,5.18,5.18,0,0,1,1.33.55c.58.42.67.93,1,1.52a2.41,2.41,0,0,0,1.52,1.22c.79.17,1.65-.11,2.42.22,1.12.47,1.64,2.12,3.07,2,.59-.05,1.07-.55,1.7-.6s1.21.24,1.84.21c1-.06,1-.64,1.42-1.27s1.08-.27,1.55-.65.48-1.85.45-2.42a2.31,2.31,0,0,1,0-1,3.45,3.45,0,0,0,.39-.9c.09-.78-.46-1.25-.65-1.93.42-.09.87.08,1.29-.09s.5-.62.8-1c.6-.7.43.1.34.53a2,2,0,0,0,.22,1.59,1.43,1.43,0,0,1,.34.61,1.45,1.45,0,0,1-.27.73,2.15,2.15,0,0,0,.11,2.15,1.76,1.76,0,0,1,.38.71,3.28,3.28,0,0,1-.13.75c0,.4.18.66.27,1,0,.12,0,.24.07.36s.21.33.29.51a1.69,1.69,0,0,1,.15.79,7.85,7.85,0,0,0,.11,1.75,2.27,2.27,0,0,0,.87,1.31A5.81,5.81,0,0,0,71,181c.34.18.68.34,1,.52a13.16,13.16,0,0,0,2.35,1.09,3.88,3.88,0,0,0,.49.11,2.47,2.47,0,0,0,.9,0c.22-.05.35-.27.53-.28.34,0,.6.12.94-.06a.77.77,0,0,0,.36-.76.94.94,0,0,0,.36-1.34,3.17,3.17,0,0,0-1.08-1c-.46-.29-1.18-.53-1.36-1.09a1.4,1.4,0,0,0-.33-.73c-.26-.26-.66-.57-.73-.94a1.45,1.45,0,0,1,.11-.71,1.25,1.25,0,0,0,0-.69c-.07-.28-.25-.52-.34-.79a1,1,0,0,1,0-.77,1.86,1.86,0,0,0-.16-1.53.89.89,0,0,1-.19-.39.91.91,0,0,1,.14-.45,2.47,2.47,0,0,0,.11-1.87c-.09-.23-.21-.5-.08-.72a1.2,1.2,0,0,1,.28-.27,1.44,1.44,0,0,0,.51-1c0-.26-.26-.43-.29-.68s.15-.39.34-.6a4.17,4.17,0,0,0,.5-.76,2.22,2.22,0,0,0,.41-.2,1.71,1.71,0,0,0,.76-1,6.3,6.3,0,0,0,.07-1.11,2,2,0,0,0,2-.27,3,3,0,0,0,1-1.83,1.93,1.93,0,0,0,1.91-1,4,4,0,0,0,.44-2.22,2.14,2.14,0,0,0,1.46-.3A1.75,1.75,0,0,0,84,156a4.86,4.86,0,0,0-.44-1.79,3,3,0,0,0,1,.34,1,1,0,0,0,.92-.33,1.32,1.32,0,0,0,0-1.24,4.81,4.81,0,0,0-.54-1c-.06-.1-.57-.77-.66-.76a1.47,1.47,0,0,0,.66-.27,1,1,0,0,0,.36-.61,1.59,1.59,0,0,0-.38-1,5.47,5.47,0,0,0-1.61-1.49c-.32-.21-.84-.35-1.07-.64a7.28,7.28,0,0,1-.48-1.06,11.6,11.6,0,0,0-3.38-4.28,8.83,8.83,0,0,0-2.42-1.25,9.78,9.78,0,0,0-1.42-.34,5,5,0,0,1-1.09-.29,2.43,2.43,0,0,0-1.17,0,2,2,0,0,0-.86.32c-.64.43-.68,1.16-1.47,1.57-.42.21-.46.59-1,.75a13.62,13.62,0,0,0-1.57.31c-1,.42-.71,1.34-1.39,2s-2.14.23-3,.77A3,3,0,0,0,61.93,146.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.45,147.24l-4.28.43L74.5,146.5l-3.67-3.4A8.14,8.14,0,0,0,76.72,150a7.76,7.76,0,0,0,5.59-.66,2.62,2.62,0,0,0,1.38-1.92v0C83.7,147.36,83.44,147.3,83.45,147.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,130A6.73,6.73,0,0,0,83.44,132a2.52,2.52,0,0,0,.75.54,1.13,1.13,0,0,0,.9,0,.67.67,0,0,0,.38-.61,3.41,3.41,0,0,0,1.77,1.25,1.68,1.68,0,0,0,1.88-.8,1.71,1.71,0,0,0-.22-1.63,3.42,3.42,0,0,0,1.1-.22,1.24,1.24,0,0,0,.74-.78,1.28,1.28,0,0,0-.49-1.22,2.84,2.84,0,0,0-.92-.46c-.19-.07-.54-.33-.74-.21a1.85,1.85,0,0,0,.48-.35.57.57,0,0,0,.13-.55.77.77,0,0,0-.56-.4,6.13,6.13,0,0,0-2.21-.23.52.52,0,0,0-.18-.67,1.41,1.41,0,0,0-.73-.18,6.09,6.09,0,0,0-2.25.24,2.93,2.93,0,0,0-1.75,1.19,2.18,2.18,0,0,0,0,1.53C81.73,128.94,81.81,129.46,82,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.86,146.77l0-.74c0-.44.07-.53.4-.14s.6.78,1.14.84a1.37,1.37,0,0,0,1.26-.58,1.28,1.28,0,0,0,.6.88,1.05,1.05,0,0,0,.61,0,2.56,2.56,0,0,0,1.69-1.27.74.74,0,0,0,.8.55,1.49,1.49,0,0,0,.9-.54,1.7,1.7,0,0,0,.48-.95.64.64,0,0,0,.74.31,1,1,0,0,0,.62-.58,2.53,2.53,0,0,0,.17-.86.31.31,0,0,0,.35.13.63.63,0,0,0,.31-.25,2.47,2.47,0,0,0,.47-1.71,6.37,6.37,0,0,0-.47-1.76,4.09,4.09,0,0,0-1.26-1.42,9.77,9.77,0,0,1-1.46-1.62c-1-1.55-1.74-5-3.25-7.27s-5.2-3.19-8.63-2c-5,1.66-5.78,5.91-6.44,10.25a3.92,3.92,0,0,1-1.59,2.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92,136.37a1.55,1.55,0,0,1-1.16,1.19,2.25,2.25,0,0,1-1.38.07,1.26,1.26,0,0,1-.89-1,1.91,1.91,0,0,1-1.59,1,1.83,1.83,0,0,1-1.46-.33,2.38,2.38,0,0,1-.5-1.89,1,1,0,0,1-1.31-.51,2.45,2.45,0,0,1-.08-1.54,6.39,6.39,0,0,1,2.19-3.94,10.79,10.79,0,0,1,6.78-1.78l.31,0A5.75,5.75,0,0,1,88,129.81a28.43,28.43,0,0,1,2.43,5.56,2.2,2.2,0,0,1-1.24.45c-.37,0-1.69,0-1.89-.42a1.17,1.17,0,0,1-.29,1.28,1.89,1.89,0,0,1-1.29.46A2.18,2.18,0,0,1,83.92,136.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,126.88a11.33,11.33,0,0,1,3.57.83,1.33,1.33,0,0,1,.78.6c.14.3-.06.76-.4.73a5.16,5.16,0,0,1,1.64.43,1.87,1.87,0,0,1,1,.93,1.17,1.17,0,0,1-.15,1.07,1.13,1.13,0,0,1-1,.43,4.27,4.27,0,0,1,.76,1,1.46,1.46,0,0,1,0,1.24,1.82,1.82,0,0,1-1.6.9c-.37,0-1.69,0-1.89-.41a1.16,1.16,0,0,1-.3,1.28,1.9,1.9,0,0,1-1.28.46,2.21,2.21,0,0,1-1.79-.77c0,.58-.6,1-1.16,1.18a2.18,2.18,0,0,1-1.38.07,1.24,1.24,0,0,1-.89-1,1.93,1.93,0,0,1-1.59,1,1.82,1.82,0,0,1-1.46-.33,2.38,2.38,0,0,1-.5-1.89,1,1,0,0,1-1.31-.52,2.44,2.44,0,0,1-.08-1.54,6.42,6.42,0,0,1,2.19-3.94A10.85,10.85,0,0,1,84.4,126.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.93,145.54c-3.72.15-5.07-1.32-5.07-1.32s-1.37,1.84.58,2.85S83.93,145.54,83.93,145.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.93,145.54c-2.21,1.68-5.94,1.3-8.31-.15a6.7,6.7,0,0,1-3-6.24s-2,.65-2.19,2.13a7.12,7.12,0,0,0,3.25,6c2.29,1.54,7.55,3,10.17.4A1.82,1.82,0,0,0,83.93,145.54Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,128.61c.21-.17-1.2-.78-1.3-.8a5,5,0,0,0-2.13.13,7.47,7.47,0,0,0-1.93,1,12.32,12.32,0,0,0-2.11,1.55,6.21,6.21,0,0,0-1.85,3,1.12,1.12,0,0,0,.25,1.19c.09.07.2.12.22.23a.34.34,0,0,1,0,.17,7.38,7.38,0,0,0-.5,2.21,2.28,2.28,0,0,0,.07.9,1,1,0,0,0,.6.62c.16.05.38.07.42.23a.62.62,0,0,1,0,.19,3.29,3.29,0,0,0,0,1.89,1,1,0,0,0,.49.64,1.1,1.1,0,0,0,.51,0c.35,0,.76-.13.92-.45a.75.75,0,0,0,.53.49,1.48,1.48,0,0,0,.75-.05,2.52,2.52,0,0,0,1.71-2,1.31,1.31,0,0,0,1.27-.38,3.11,3.11,0,0,0,.88-2,13.47,13.47,0,0,0,0-2.2,19.92,19.92,0,0,1,.12-3.78A4.11,4.11,0,0,1,79.2,128.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.79,143a3.12,3.12,0,0,1-2.54-1,1.4,1.4,0,0,1,.35-2,4.91,4.91,0,0,1,2.45-.68,1.58,1.58,0,0,1,1.12,1.36A2.63,2.63,0,0,1,92.79,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,168.55c0-.11,0-.21,0-.27a5.45,5.45,0,0,1-.16-1.23,1.5,1.5,0,0,0-.3-1.18,6.94,6.94,0,0,1-.69-1c-.31-.52-.81-.6-1.35-.76a6.4,6.4,0,0,1-1.36-.74,3.06,3.06,0,0,0-2-.24c-.54.1-.82.49-1.3.66s-2.12.48-2,1.26c.27-.12.42-.42.71-.56a2.61,2.61,0,0,1,1.33-.14c.74,0,1.33-.45,2.1-.28a2.63,2.63,0,0,1,1.31.68c.36.37.3.68.42,1.13s.41.41.74.59a2.18,2.18,0,0,1,.8.85,1.83,1.83,0,0,1,.23,1.07c0,.21-.14.34-.15.52l.09,0,0-.07c.42-.09.87.08,1.29-.09A.85.85,0,0,0,67,168.55Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,166.12a2.36,2.36,0,1,1-2.35-2.35A2.36,2.36,0,0,1,187.83,166.12Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.48 166.62 162.42 166.62 149.45 156.37 106.78 156.37 106.78 155.37 149.8 155.37 162.77 165.62 185.48 165.62 185.48 166.62",
    style: {
      fill: "#603FEF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Travel--inject-136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.4,
    cy: 68.68,
    r: 37.4,
    transform: "translate(0.47 138.49) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,107.08a38.4,38.4,0,1,1,38.4-38.4A38.44,38.44,0,0,1,167.4,107.08Zm0-74.8a36.4,36.4,0,1,0,36.4,36.4A36.44,36.44,0,0,0,167.4,32.28Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M154.51,97.17l-14-8.08a.76.76,0,0,1,0-1.44L176.4,67a2.73,2.73,0,0,1,2.49,0l14,8.07a.76.76,0,0,1,0,1.44L157,97.17A2.82,2.82,0,0,1,154.51,97.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Suitcase--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.61,39.81l-32.85,19a2,2,0,0,0-.92,1.6V87.29a2,2,0,0,0,.92,1.6L155.35,95a2,2,0,0,0,1.85,0L190,76a2.06,2.06,0,0,0,.93-1.6V47.53a2,2,0,0,0-.93-1.6l-10.59-6.12A2.05,2.05,0,0,0,177.61,39.81Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,66.65l-12.44-7.18a1.84,1.84,0,0,0-.27.91V87.29a2,2,0,0,0,.92,1.6L155.35,95a2.08,2.08,0,0,0,1.66.09c-.42.14-.74-.1-.74-.62V67.56A1.87,1.87,0,0,1,156.55,66.65Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,66.65l-12.44-7.18a1.84,1.84,0,0,0-.27.91V87.29a2,2,0,0,0,.92,1.6L155.35,95a2.08,2.08,0,0,0,1.66.09c-.42.14-.74-.1-.74-.62V67.56A1.87,1.87,0,0,1,156.55,66.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,45.93l-10.59-6.12a2.05,2.05,0,0,0-1.84,0l-32.85,19a1.89,1.89,0,0,0-.65.69l12.44,7.18a1.81,1.81,0,0,1,.65-.69L190,47c.48-.28.87-.09.92.42A2,2,0,0,0,190,45.93Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,95,190,76a2,2,0,0,0,.93-1.6V47.53c0-.59-.42-.83-.93-.53L157.2,66a2,2,0,0,0-.93,1.6V94.47C156.27,95.06,156.69,95.3,157.2,95Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,95,190,76a2,2,0,0,0,.93-1.6V47.53c0-.59-.42-.83-.93-.53L157.2,66a2,2,0,0,0-.93,1.6V94.47C156.27,95.06,156.69,95.3,157.2,95Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.57,92.57a.17.17,0,0,0,0,.07v.68l.58-.34a.13.13,0,0,0,.05-.19.15.15,0,0,0-.19-.06l-.16.09v-.18a.14.14,0,0,0-.14-.14A.17.17,0,0,0,157.57,92.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.73,92.31l.73-.42a.13.13,0,0,1,.19,0,.15.15,0,0,1-.05.2l-.73.42a.13.13,0,0,1-.19,0,.14.14,0,0,1,0-.15A.12.12,0,0,1,158.73,92.31Zm1.46-.84.73-.42a.13.13,0,0,1,.19,0,.13.13,0,0,1-.05.19l-.73.43a.15.15,0,0,1-.19-.06.14.14,0,0,1,.05-.19Zm1.46-.85.73-.42a.15.15,0,0,1,.2.06.14.14,0,0,1-.06.19l-.73.42a.14.14,0,0,1-.19-.05.12.12,0,0,1,0-.14Zm1.46-.84.73-.42a.15.15,0,0,1,.2,0,.16.16,0,0,1,0,.2l-.73.42a.16.16,0,0,1-.2,0,.16.16,0,0,1,0-.15A.12.12,0,0,1,163.11,89.78Zm1.46-.84.74-.43a.15.15,0,0,1,.19.06.14.14,0,0,1-.05.19l-.73.42a.15.15,0,0,1-.2-.05.17.17,0,0,1,0-.14A.12.12,0,0,1,164.57,88.94Zm1.47-.85.73-.42a.13.13,0,0,1,.19,0,.15.15,0,0,1-.05.2l-.73.42a.15.15,0,0,1-.2,0,.19.19,0,0,1,0-.15Zm1.46-.84.73-.42a.14.14,0,0,1,.14.24l-.73.43a.15.15,0,0,1-.19-.06.14.14,0,0,1,.05-.19Zm22-37.19a.15.15,0,0,1,.15.14V51a.15.15,0,1,1-.29,0V50.2a.14.14,0,0,1,0-.07A.14.14,0,0,1,189.54,50.06ZM169,86.4l.73-.42a.16.16,0,0,1,.2,0,.15.15,0,0,1-.06.2l-.73.42a.13.13,0,0,1-.19-.05.12.12,0,0,1,0-.14Zm20.58-34.65a.15.15,0,0,1,.15.14v.84a.15.15,0,0,1-.15.15.15.15,0,0,1-.14-.15v-.84a.14.14,0,0,1,0-.07A.14.14,0,0,1,189.54,51.75ZM170.42,85.56l.73-.42a.15.15,0,0,1,.2,0,.16.16,0,0,1,0,.2l-.74.42a.15.15,0,0,1-.19,0,.16.16,0,0,1,0-.15A.12.12,0,0,1,170.42,85.56Zm19.12-32.13a.15.15,0,0,1,.15.15v.84a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.84a.14.14,0,0,1,0-.07A.13.13,0,0,1,189.54,53.43ZM171.88,84.72l.74-.43a.15.15,0,0,1,.19.06.14.14,0,0,1-.05.19L172,85a.15.15,0,0,1-.2,0,.17.17,0,0,1,0-.14A.12.12,0,0,1,171.88,84.72Zm17.66-29.6a.15.15,0,0,1,.15.14v.85a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.85a.19.19,0,0,1,0-.07A.14.14,0,0,1,189.54,55.12ZM173.35,83.87l.73-.42a.13.13,0,0,1,.19,0,.15.15,0,0,1-.05.2l-.73.42a.15.15,0,0,1-.2-.05.2.2,0,0,1,0-.15Zm16.19-27.06a.15.15,0,0,1,.15.14v.85a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14V57a.19.19,0,0,1,0-.07A.14.14,0,0,1,189.54,56.81ZM174.81,83l.73-.42a.14.14,0,0,1,.14.24l-.73.42a.13.13,0,0,1-.19,0,.14.14,0,0,1,.05-.19ZM189.54,58.5a.15.15,0,0,1,.15.14v.84a.15.15,0,0,1-.15.15.15.15,0,0,1-.14-.15v-.84a.19.19,0,0,1,0-.07A.15.15,0,0,1,189.54,58.5ZM176.27,82.18l.73-.42a.16.16,0,0,1,.2,0,.16.16,0,0,1-.06.2l-.73.42a.13.13,0,0,1-.19-.05.12.12,0,0,1,0-.14Zm13.27-22a.15.15,0,0,1,.15.14v.84a.15.15,0,0,1-.15.15.15.15,0,0,1-.14-.15v-.84a.14.14,0,0,1,0-.07A.14.14,0,0,1,189.54,60.19ZM177.73,81.34l.73-.42a.15.15,0,0,1,.2,0,.14.14,0,0,1,0,.19l-.74.43a.14.14,0,0,1-.19-.2A.12.12,0,0,1,177.73,81.34Zm11.81-19.47a.15.15,0,0,1,.15.15v.84a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14V62a.14.14,0,0,1,0-.07A.13.13,0,0,1,189.54,61.87ZM179.19,80.5l.73-.43a.15.15,0,0,1,.2.06.14.14,0,0,1-.05.19l-.73.42a.15.15,0,0,1-.2,0,.17.17,0,0,1,0-.14A.12.12,0,0,1,179.19,80.5Zm10.35-16.94a.15.15,0,0,1,.15.14v.85a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.84a.19.19,0,0,1,0-.08A.14.14,0,0,1,189.54,63.56Zm-8.88,16.09.73-.42a.14.14,0,0,1,.19,0,.15.15,0,0,1-.05.2l-.73.42a.16.16,0,0,1-.2-.05.19.19,0,0,1,0-.15Zm8.88-14.4a.15.15,0,0,1,.15.14v.85a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.85a.19.19,0,0,1,0-.07A.14.14,0,0,1,189.54,65.25Zm-7.42,13.56.73-.42a.14.14,0,0,1,.14.24l-.73.42a.13.13,0,0,1-.19,0,.14.14,0,0,1,.05-.19Zm7.42-11.87a.15.15,0,0,1,.15.14v.85a.15.15,0,0,1-.15.14.15.15,0,0,1-.14-.14v-.85a.19.19,0,0,1,0-.07A.14.14,0,0,1,189.54,66.94Zm-6,11,.73-.42a.16.16,0,0,1,.2,0,.16.16,0,0,1-.06.2l-.73.42a.13.13,0,0,1-.19,0,.12.12,0,0,1,0-.14Zm6-9.33a.15.15,0,0,1,.15.14v.84a.15.15,0,1,1-.29,0v-.84a.14.14,0,0,1,0-.07A.14.14,0,0,1,189.54,68.63ZM185,77.12l.73-.42a.15.15,0,0,1,.2,0,.14.14,0,0,1-.06.19l-.73.43a.14.14,0,0,1-.19-.06.14.14,0,0,1,0-.19Zm4.5-6.8a.14.14,0,0,1,.15.14v.84a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.84a.14.14,0,0,1,0-.07A.11.11,0,0,1,189.54,70.32Zm-3,6,.73-.43a.15.15,0,0,1,.2.06.15.15,0,0,1-.05.19l-.73.42a.15.15,0,0,1-.2,0,.14.14,0,0,1,0-.14A.12.12,0,0,1,186.5,76.28Zm3-4.28a.15.15,0,0,1,.15.15V73a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.84a.24.24,0,0,1,0-.08A.14.14,0,0,1,189.54,72ZM188,75.43l.73-.42a.14.14,0,0,1,.19,0,.15.15,0,0,1,0,.2l-.73.42a.16.16,0,0,1-.2-.05.2.2,0,0,1,0-.15S187.94,75.44,188,75.43Zm1.57-1.74a.15.15,0,0,1,.15.14v.61a.83.83,0,0,1-.1.27l0,0a.13.13,0,0,1-.19,0,.16.16,0,0,1,0-.2c0-.08,0-.14.06-.14v-.6a.19.19,0,0,1,0-.07A.14.14,0,0,1,189.54,73.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,49.07a.14.14,0,0,0,.19.2l.16-.09v.18a.15.15,0,0,0,.14.14.15.15,0,0,0,.15-.14v-.68l-.59.34A.12.12,0,0,0,189.05,49.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.67,67.27a.13.13,0,0,1,.19,0,.16.16,0,0,1,0,.2c0,.08-.05.14-.06.14v.6a.14.14,0,1,1-.28,0v-.61a.59.59,0,0,1,.09-.27Zm.73-.53.73-.42a.15.15,0,1,1,.15.25l-.74.42a.14.14,0,0,1-.19,0,.14.14,0,0,1,0-.14S158.38,66.76,158.4,66.74Zm-.7,2.13a.14.14,0,0,1,.14.14v.84a.14.14,0,1,1-.28,0V69a.15.15,0,0,1,0-.07A.16.16,0,0,1,157.7,68.87Zm2.16-3,.74-.42a.14.14,0,0,1,.19,0,.13.13,0,0,1,0,.19l-.73.43a.15.15,0,0,1-.2-.06.17.17,0,0,1,0-.14A.12.12,0,0,1,159.86,65.9Zm-2.16,4.66a.14.14,0,0,1,.14.14v.84a.14.14,0,1,1-.28,0V70.7a.15.15,0,0,1,0-.07A.16.16,0,0,1,157.7,70.56Zm3.63-5.5.73-.43a.14.14,0,0,1,.14.25l-.73.42a.15.15,0,0,1-.2,0,.17.17,0,0,1,0-.14S161.3,65.07,161.33,65.06Zm-3.63,7.18a.15.15,0,0,1,.14.15v.84a.14.14,0,1,1-.28,0v-.84a.15.15,0,0,1,0-.07A.14.14,0,0,1,157.7,72.24Zm5.09-8,.73-.42a.13.13,0,0,1,.19.05.15.15,0,0,1-.05.2l-.73.42a.14.14,0,0,1-.19,0,.14.14,0,0,1,0-.15A.12.12,0,0,1,162.79,64.21Zm-5.09,9.72a.15.15,0,0,1,.14.15v.84a.14.14,0,1,1-.28,0v-.84a.19.19,0,0,1,0-.08A.16.16,0,0,1,157.7,73.93Zm6.55-10.56L165,63a.15.15,0,0,1,.2,0,.14.14,0,0,1-.06.19l-.73.42a.13.13,0,0,1-.19,0,.14.14,0,0,1,.05-.19ZM157.7,75.62a.14.14,0,0,1,.14.14v.85a.14.14,0,1,1-.28,0v-.85a.17.17,0,0,1,0-.07A.16.16,0,0,1,157.7,75.62Zm8-13.1.73-.42a.15.15,0,0,1,.15.25l-.74.42a.14.14,0,0,1-.19-.05.14.14,0,0,1,0-.14S165.69,62.54,165.71,62.52Zm-8,14.79a.14.14,0,0,1,.14.14v.85a.14.14,0,1,1-.28,0v-.85a.12.12,0,0,1,.14-.14Zm9.47-15.63.74-.42a.14.14,0,0,1,.19.05.13.13,0,0,1,0,.19l-.73.43a.15.15,0,0,1-.2-.06.17.17,0,0,1,0-.14A.12.12,0,0,1,167.17,61.68ZM157.7,79a.14.14,0,0,1,.14.14V80a.14.14,0,1,1-.28,0v-.84a.15.15,0,0,1,0-.07A.16.16,0,0,1,157.7,79Zm10.94-18.16.73-.43a.14.14,0,0,1,.19.06.14.14,0,0,1-.05.19l-.73.42a.15.15,0,0,1-.2,0,.17.17,0,0,1,0-.14S168.61,60.85,168.64,60.84ZM157.7,80.69a.14.14,0,0,1,.14.14v.84a.14.14,0,1,1-.28,0v-.84a.15.15,0,0,1,0-.07A.15.15,0,0,1,157.7,80.69ZM170.1,60l.73-.42a.13.13,0,0,1,.19,0,.15.15,0,0,1-.05.2l-.73.42a.14.14,0,0,1-.19-.05.14.14,0,0,1,0-.15A.12.12,0,0,1,170.1,60ZM157.7,82.37a.15.15,0,0,1,.14.15v.84a.14.14,0,1,1-.28,0v-.84a.22.22,0,0,1,0-.08A.17.17,0,0,1,157.7,82.37Zm13.86-23.22.73-.42a.14.14,0,1,1,.14.24l-.73.42a.13.13,0,0,1-.19,0,.14.14,0,0,1,.05-.19ZM157.7,84.06a.14.14,0,0,1,.14.14v.85a.14.14,0,1,1-.28,0V84.2a.17.17,0,0,1,0-.07A.16.16,0,0,1,157.7,84.06ZM173,58.3l.73-.42a.16.16,0,0,1,.2,0,.15.15,0,0,1-.06.2l-.73.42a.14.14,0,0,1-.19,0,.12.12,0,0,1,0-.14S173,58.32,173,58.3ZM157.7,85.75a.14.14,0,0,1,.14.14v.85a.14.14,0,1,1-.28,0v-.85a.17.17,0,0,1,0-.07A.16.16,0,0,1,157.7,85.75Zm16.78-28.29.73-.42a.15.15,0,0,1,.2.05.13.13,0,0,1,0,.19l-.73.43a.15.15,0,0,1-.2-.06.14.14,0,0,1,0-.14A.12.12,0,0,1,174.48,57.46Zm-16.78,30a.14.14,0,0,1,.14.14v.84a.14.14,0,1,1-.28,0v-.84a.15.15,0,0,1,0-.07A.16.16,0,0,1,157.7,87.44ZM176,56.62l.73-.43a.14.14,0,0,1,.19.06.14.14,0,0,1-.05.19l-.73.42a.15.15,0,0,1-.2,0,.17.17,0,0,1,0-.14S175.92,56.63,176,56.62ZM157.7,89.13a.14.14,0,0,1,.14.14v.84a.14.14,0,1,1-.28,0v-.84a.15.15,0,0,1,0-.07A.15.15,0,0,1,157.7,89.13Zm19.71-33.36.73-.42a.13.13,0,0,1,.19,0,.15.15,0,0,1-.05.2l-.73.42a.14.14,0,0,1-.19-.05.14.14,0,0,1,0-.15A.08.08,0,0,1,177.41,55.77Zm-19.71,35a.15.15,0,0,1,.14.15v.84a.14.14,0,1,1-.28,0V91a.22.22,0,0,1,0-.08A.17.17,0,0,1,157.7,90.81Zm21.17-35.88.73-.42a.13.13,0,0,1,.19.05.13.13,0,0,1,0,.19l-.73.42a.13.13,0,0,1-.19-.05.14.14,0,0,1,.05-.19Zm1.46-.85.73-.42a.16.16,0,0,1,.2.05.15.15,0,0,1-.06.2l-.73.42a.14.14,0,0,1-.19,0,.12.12,0,0,1,0-.14S180.31,54.1,180.33,54.08Zm1.46-.84.73-.42a.15.15,0,0,1,.2,0,.14.14,0,0,1-.05.19l-.73.43a.15.15,0,0,1-.2-.06.14.14,0,0,1,0-.14A.12.12,0,0,1,181.79,53.24Zm1.47-.84L184,52a.14.14,0,0,1,.19.06.14.14,0,0,1-.05.19l-.73.42a.15.15,0,0,1-.2,0,.17.17,0,0,1,0-.14A.1.1,0,0,1,183.26,52.4Zm1.46-.85.73-.42a.13.13,0,0,1,.19,0,.15.15,0,0,1,0,.2l-.73.42a.16.16,0,0,1-.2,0,.19.19,0,0,1,0-.15S184.69,51.56,184.72,51.55Zm1.46-.84.73-.42a.14.14,0,1,1,.14.24l-.73.42a.13.13,0,0,1-.19-.05.14.14,0,0,1,.05-.19Zm1.46-.85.73-.42a.16.16,0,0,1,.2.05.15.15,0,0,1-.06.2l-.73.42a.14.14,0,0,1-.19,0,.12.12,0,0,1,0-.14S187.62,49.88,187.64,49.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.78,92.36V63.88a1,1,0,0,1,.49-.85l34.2-19.75-1.16-.66-34.2,19.75a1,1,0,0,0-.49.85V91.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.28,71.56l0,0a10.54,10.54,0,0,0,3-3.36A10.7,10.7,0,0,0,160.71,64h0l-3.47,2a1.81,1.81,0,0,0-.65.69,1.87,1.87,0,0,0-.27.91v4",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,47.53V51c-2.13,1.21-3.85.21-3.85-2.25v0L190,47C190.55,46.7,191,46.94,191,47.53Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.21,95l3-1.71c0-2.44-1.74-3.43-3.87-2.2h0v3.36C156.28,95.05,156.7,95.29,157.21,95Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,70.72v3.72A2,2,0,0,1,190,76l-3.17,1.84c0-.11,0-.22,0-.33a8.53,8.53,0,0,1,3.87-6.7Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.28,71.56l0,0a10.54,10.54,0,0,0,3-3.36A10.7,10.7,0,0,0,160.71,64h0l-3.47,2a1.81,1.81,0,0,0-.65.69,1.87,1.87,0,0,0-.27.91v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191,47.53V51c-2.13,1.21-3.85.21-3.85-2.25v0L190,47C190.55,46.7,191,46.94,191,47.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.21,95l3-1.71c0-2.44-1.74-3.43-3.87-2.2h0v3.36C156.28,95.05,156.7,95.29,157.21,95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191,70.72v3.72A2,2,0,0,1,190,76l-3.17,1.84c0-.11,0-.22,0-.33a8.53,8.53,0,0,1,3.87-6.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,64a9.86,9.86,0,0,0-7.94.48l3.82,2.21a1.81,1.81,0,0,1,.65-.69Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,47l-2.93,1.69c-2.12-1.23-1.87-3.08.26-4.31l2.68,1.55a2,2,0,0,1,.92,1.6v.24h0v-.24C191,46.94,190.55,46.7,190,47Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,39.81l3,1.73a8.56,8.56,0,0,1-7.73,0l0,0,3.06-1.75A2,2,0,0,1,179.45,39.81Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71,57.08c2.12,1.23,2.12,3.22,0,4.45h0l-3.58-2.07a1.88,1.88,0,0,1,.65-.69Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.67,64a9.86,9.86,0,0,0-7.94.48l3.82,2.21a1.81,1.81,0,0,1,.65-.69Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190,47l-2.93,1.69c-2.12-1.23-1.87-3.08.26-4.31l2.68,1.55a2,2,0,0,1,.92,1.6v.24h0v-.24C191,46.94,190.55,46.7,190,47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.45,39.81l3,1.73a8.56,8.56,0,0,1-7.73,0l0,0,3.06-1.75A2,2,0,0,1,179.45,39.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.71,57.08c2.12,1.23,2.12,3.22,0,4.45h0l-3.58-2.07a1.88,1.88,0,0,1,.65-.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,66.65l-3.82-2.21a9.89,9.89,0,0,0,3.55,7.12v-4A1.81,1.81,0,0,1,156.55,66.65Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,63.78V60.37a1.81,1.81,0,0,1,.27-.9l3.58,2.07C147.69,64,146,65,143.84,63.78Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.7,90.46v.12l-2.94-1.7a2,2,0,0,1-.92-1.46V83.76h0A8.55,8.55,0,0,1,147.7,90.46Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.29,94.47V91.08c-2.13-1.22-3.85-.22-3.85,2.24L155.36,95a2.08,2.08,0,0,0,1.85,0h0C156.7,95.29,156.29,95.06,156.29,94.47Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.55,66.65l-3.82-2.21a9.89,9.89,0,0,0,3.55,7.12v-4A1.81,1.81,0,0,1,156.55,66.65Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M143.84,63.78V60.37a1.81,1.81,0,0,1,.27-.9l3.58,2.07C147.69,64,146,65,143.84,63.78Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7,90.46v.12l-2.94-1.7a2,2,0,0,1-.92-1.46V83.76h0A8.55,8.55,0,0,1,147.7,90.46Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.29,94.47V91.08c-2.13-1.22-3.85-.22-3.85,2.24L155.36,95a2.08,2.08,0,0,0,1.85,0h0C156.7,95.29,156.29,95.06,156.29,94.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.94,58.79l-1.82,1.05a.6.6,0,0,1-.49,0l-3-1.72a.56.56,0,0,1-.24-.43V57.5a.56.56,0,0,1,.24-.43l1.82-1a.55.55,0,0,1,.5,0l3,1.72a.54.54,0,0,1,.25.43v.19A.54.54,0,0,1,160.94,58.79Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.94,58.79l-1.82,1.05a.6.6,0,0,1-.49,0l-3-1.72a.56.56,0,0,1-.24-.43V57.5a.56.56,0,0,1,.24-.43l1.82-1a.55.55,0,0,1,.5,0l3,1.72a.54.54,0,0,1,.25.43v.19A.54.54,0,0,1,160.94,58.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6,57.11a.54.54,0,0,0-.19.39v.19a.56.56,0,0,0,.24.43l3,1.72a.66.66,0,0,0,.25.06v-.76a.51.51,0,0,1-.25-.06l-3-1.72C155.53,57.29,155.52,57.19,155.6,57.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,59.08l-3-1.72a.16.16,0,0,1,0-.29l1.82-1a.55.55,0,0,1,.5,0l3,1.72a.15.15,0,0,1,0,.29l-1.82,1A.53.53,0,0,1,158.63,59.08Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,59.08l-3-1.72a.16.16,0,0,1,0-.29l1.82-1a.55.55,0,0,1,.5,0l3,1.72a.15.15,0,0,1,0,.29l-1.82,1A.53.53,0,0,1,158.63,59.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,48.1l-1.82,1a.55.55,0,0,1-.5,0l-3-1.71a.54.54,0,0,1-.25-.43v-.19a.54.54,0,0,1,.25-.43l1.82-1a.53.53,0,0,1,.49,0l3,1.72a.56.56,0,0,1,.24.43v.19A.56.56,0,0,1,179.45,48.1Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,48.1l-1.82,1a.55.55,0,0,1-.5,0l-3-1.71a.54.54,0,0,1-.25-.43v-.19a.54.54,0,0,1,.25-.43l1.82-1a.53.53,0,0,1,.49,0l3,1.72a.56.56,0,0,1,.24.43v.19A.56.56,0,0,1,179.45,48.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.11,46.43a.52.52,0,0,0-.2.39V47a.51.51,0,0,0,.25.42l3,1.72a.42.42,0,0,0,.25.06v-.76h0a.51.51,0,0,1-.25-.06l-3-1.71C174,46.61,174,46.51,174.11,46.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.13,48.39l-3-1.71a.15.15,0,0,1,0-.29l1.82-1a.53.53,0,0,1,.49,0l3,1.72c.13.08.13.21,0,.28l-1.82,1A.55.55,0,0,1,177.13,48.39Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.13,48.39l-3-1.71a.15.15,0,0,1,0-.29l1.82-1a.53.53,0,0,1,.49,0l3,1.72c.13.08.13.21,0,.28l-1.82,1A.55.55,0,0,1,177.13,48.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.17,53.38,161,52.69a.36.36,0,0,0-.32,0l-2,1.14a.35.35,0,0,0-.17.28v.12a.37.37,0,0,0,.17.29l1.2.69a.38.38,0,0,0,.33,0l2-1.13a.37.37,0,0,0,.16-.29v-.12A.37.37,0,0,0,162.17,53.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.62,52.68l-2,1.14c-.09,0-.09.13,0,.19l1.21.69a.36.36,0,0,0,.32,0l2-1.14c.09-.05.09-.13,0-.18l-1.2-.7A.38.38,0,0,0,160.62,52.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.16,47.62l-1.21-.7a.38.38,0,0,0-.33,0l-2,1.14a.36.36,0,0,0-.16.28v.13a.36.36,0,0,0,.16.28l1.21.69a.32.32,0,0,0,.33,0l2-1.13a.36.36,0,0,0,.17-.29V47.9A.34.34,0,0,0,172.16,47.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61,46.91l-2,1.14a.1.1,0,0,0,0,.19l1.2.69a.38.38,0,0,0,.33,0l2-1.13c.09-.06.09-.14,0-.19l-1.2-.7A.38.38,0,0,0,170.61,46.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,47.63l-1.16.67v-.75h0v.75l-.5-.29v-.75l-.58-.33a1.61,1.61,0,0,0-1.48,0l-7.41,4.27a1.26,1.26,0,0,0-.17.13l.16.13,1.09.63v.59h0v.74l-1.16.67-.5-.29v-.75l-1-.57a.73.73,0,0,1-.41-.56c0-.13,0-.58,0-.67,0-.5.49-1.13,1.39-1.65L165.57,46c1.36-.79,3.13-1,4-.56l1.49.86Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,47.63l-1.16.67v-.75h0v.75l-.5-.29v-.75l-.58-.33a1.61,1.61,0,0,0-1.48,0l-7.41,4.27a1.26,1.26,0,0,0-.17.13l.16.13,1.09.63v.59h0v.74l-1.16.67-.5-.29v-.75l-1-.57a.73.73,0,0,1-.41-.56c0-.13,0-.58,0-.67,0-.5.49-1.13,1.39-1.65L165.57,46c1.36-.79,3.13-1,4-.56l1.49.86Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32,51.89c-.82-.47-.38-1.49,1-2.28L165.57,46c1.36-.79,3.13-1,4-.56l1.49.86v1.33l-1.16.67V47l-1.08-.62a1.67,1.67,0,0,0-1.48,0l-7.42,4.28a.45.45,0,0,0,0,.85l1.09.63v1.34l-1.16.67V52.75Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32,51.89c-.82-.47-.38-1.49,1-2.28L165.57,46c1.36-.79,3.13-1,4-.56l1.49.86v1.33l-1.16.67V47l-1.08-.62a1.67,1.67,0,0,0-1.48,0l-7.42,4.28a.45.45,0,0,0,0,.85l1.09.63v1.34l-1.16.67V52.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.02 47.63 169.86 48.3 169.86 46.95 171.01 46.3 171.02 47.63",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.02 47.63 169.86 48.3 169.86 46.95 171.01 46.3 171.02 47.63",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.97 53.43 159.81 54.1 159.81 52.75 160.97 52.09 160.97 53.43",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.97 53.43 159.81 54.1 159.81 52.75 160.97 52.09 160.97 53.43",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.72 89.52 164.22 90.96 164.22 61.94 166.72 60.49 166.72 89.52",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.2 81.16 183.7 79.71 183.7 50.69 181.2 52.13 181.2 81.16",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.47,78.55h0c-.69.4-1.25,0-1.25-.94V75l2.5-1.45v2.62A3,3,0,0,1,165.47,78.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.47,77.81h0c-.69.4-1.25,0-1.25-.94V74.25l2.5-1.44v2.61A3,3,0,0,1,165.47,77.81Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.45,68.75h0c-.69.4-1.25,0-1.25-1V65.19l2.5-1.45v2.62A3,3,0,0,1,182.45,68.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.45,68h0c-.69.4-1.25,0-1.25-1V64.45L183.7,63v2.62A3,3,0,0,1,182.45,68Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,72.64l3.44-2c.2-.12.37,0,.37.28v1.63a.91.91,0,0,1-.37.71l-3.44,2c-.2.12-.37,0-.37-.28V73.35A.9.9,0,0,1,163.75,72.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,62.84l3.44-2c.2-.11.37,0,.37.28v1.64a.89.89,0,0,1-.37.7l-3.44,2c-.2.11-.37,0-.37-.28V63.54A.88.88,0,0,1,180.73,62.84Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,71.9l3.44-2c.2-.12.37,0,.37.28v1.63a.91.91,0,0,1-.37.71l-3.44,2c-.2.12-.37,0-.37-.28V72.61A.9.9,0,0,1,163.75,71.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,62.1l3.44-2c.2-.11.37,0,.37.28V62a.88.88,0,0,1-.37.7l-3.44,2c-.2.11-.37,0-.37-.28V62.8A.88.88,0,0,1,180.73,62.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.25 61.77 176.67 58.65 176.67 62.36 171.25 65.49 171.25 61.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,66V61.6l6-3.46v4.39Zm.58-4.06v3l4.83-2.79v-3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "191.37 148.5 166.9 129.74 166.9 106.08 167.9 106.08 167.9 129.25 191.98 147.71 191.37 148.5",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,148.11a2.36,2.36,0,1,1-2.35-2.36A2.35,2.35,0,0,1,194,148.11Z",
    style: {
      fill: "#603FEF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Food--inject-136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 332.6,
    cy: 68.68,
    r: 37.4,
    transform: "translate(48.85 255.3) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,107.08A38.4,38.4,0,1,1,371,68.68,38.44,38.44,0,0,1,332.6,107.08Zm0-74.8A36.4,36.4,0,1,0,369,68.68,36.44,36.44,0,0,0,332.6,32.28Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pizza--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M308.86,58.9c-13.5,7.79-13.5,20.43,0,28.22s35.38,7.79,48.88,0,13.49-20.43,0-28.22S322.35,51.11,308.86,58.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plate--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357,57.29c-13.24-7.64-34.71-7.64-47.95,0h0V55.92c-6.92,4-10.21,9.29-9.9,14.52-.31,5.24,3,10.53,9.9,14.53,13.24,7.64,34.71,7.64,47.94,0S370.26,64.94,357,57.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,55.92c13.23,7.64,13.23,20,0,27.67s-34.7,7.65-47.94,0-13.23-20,0-27.67S343.79,48.27,357,55.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8,58.58c-9.1,5.25-9.1,13.77,0,19s23.85,5.25,32.95,0,9.09-13.77,0-19S325.9,53.33,316.8,58.58Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8,58.58c-9.1,5.25-9.1,13.77,0,19s23.85,5.25,32.95,0,9.09-13.77,0-19S325.9,53.33,316.8,58.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,59.23c-8.48,4.89-8.48,12.83,0,17.72s22.23,4.9,30.71,0,8.47-12.83,0-17.72S326.4,54.33,317.92,59.23Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.71,72A21.46,21.46,0,0,0,364,68.22a23.37,23.37,0,0,0-4.84-4.37,30.48,30.48,0,0,0-7.7-3.14c-3-.92-6.12-1.86-9.28-1.74-3.83.14-7.42,1.81-10.89,3.45l-17.46,8.25-8.67,4.09c-.83.39-2.91,1-3.84,1.87a17.87,17.87,0,0,0,2.45,3l.21,0c12.74,2.62,25.81,3.17,38.81,3.29q7.71.06,15.42-.08C363.09,79.76,365.92,76,366.71,72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,74.66h0a3.21,3.21,0,0,0,2.84,3c2.12.23,5.44.5,9.8.59,8,.14,42.86,1.45,44.51.37,2.65-1.72-.56-5.73-.56-5.73l-54.31,1Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.09,49.6a6.14,6.14,0,0,1,5.41-.19A10.17,10.17,0,0,1,351.9,52c1.39,1.55,3.12,1.46,7.07,4.26s3.78,4.43,4.51,5.92c.62,1.27.21,2.94.67,4.3s1.75,2.44,2.4,3.78a6.07,6.07,0,0,1,.56,4.09,3.73,3.73,0,0,1-2.84,2.79c-.45.07-.92.05-1.35.16a8,8,0,0,0-1.57.79c-1.16.6-2.89,1.33-4,.68-1.38-.78-1.64-2-1.64-4-.57-1.58-2.27-3.15-3.25-4.52q-2.87-4-5.75-8c-.45-.63-7.23-10.26-7.32-10.2Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09,65.49l.88,1.22L352,69.6l.63.86.06.08a5.5,5.5,0,0,0,.79.81,3.07,3.07,0,0,1,1,1.36,7.57,7.57,0,0,1,1.18,2c0,2,.26,3.27,1.64,4,1.13.65,2.86-.08,4-.68a8,8,0,0,1,1.57-.79c.43-.11.9-.09,1.35-.16a3.73,3.73,0,0,0,2.84-2.79,6.07,6.07,0,0,0-.56-4.09,10.86,10.86,0,0,0-1.23-1.83,2.58,2.58,0,0,1-.62,3c-1,.66-4.38.3-5.73-.42s-.83-2.94-1.25-4-2.39-1.8-2-4-1-3.85-4.15-4.91-3.61-2.36-4.88-3.8-4.77-1.86-7.29-2.33c.09-.06,6.86,9.55,7.32,10.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.37,52a42.36,42.36,0,0,1,9,6.79,1.14,1.14,0,0,0,.11.11l.36.37h0c4.36,4.58,6.84,9.84,6.84,15.44H300l4-2.28,1.45-.84.19-.11Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.37,52a42.36,42.36,0,0,1,9,6.79,1.14,1.14,0,0,0,.11.11l.36.37h0c4.36,4.58,6.84,9.84,6.84,15.44H300l4-2.28,1.45-.84.19-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05,67.3a4.06,4.06,0,0,1,1.68,1.63c.64,1.29.08,2.73-1.68,3.75a10.34,10.34,0,0,1-9.32,0,3.18,3.18,0,0,1-1.92-2.83,3.33,3.33,0,0,1,1.92-2.55A10.34,10.34,0,0,1,318.05,67.3Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83,62.9a10.71,10.71,0,0,1,3.2.45c2.05.63,3.46,1.87,3.49,3.3.06,2.1-2.85,3.82-6.49,3.86a9.53,9.53,0,0,1-4.85-1.17,3.28,3.28,0,0,1-1.84-2.58C325.29,64.66,328.19,62.94,331.83,62.9Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,66.19a10.7,10.7,0,0,1,3.19.44c2.05.63,3.46,1.87,3.5,3.3.05,2.1-2.86,3.83-6.5,3.86a9.46,9.46,0,0,1-4.85-1.17A3.27,3.27,0,0,1,340.45,70C340.4,68,343.3,66.22,347,66.19Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.16,53.52a10.76,10.76,0,0,1,3.2.45c2.05.63,3.45,1.86,3.49,3.3,0,2.1-2.85,3.82-6.49,3.85A9.31,9.31,0,0,1,336.51,60a3.21,3.21,0,0,1-1.84-2.57C334.61,55.28,337.52,53.55,341.16,53.52Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "308.63 148.5 308.02 147.71 332.1 129.25 332.1 106.08 333.1 106.08 333.1 129.74 332.9 129.89 308.63 148.5",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,148.11a2.36,2.36,0,1,0,2.35-2.36A2.35,2.35,0,0,0,306,148.11Z",
    style: {
      fill: "#603FEF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ubication--inject-136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 430.62,
    cy: 155.87,
    r: 37.4,
    transform: "translate(179.98 539.16) rotate(-76.72)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.62,194.27a38.4,38.4,0,1,1,38.4-38.4A38.44,38.44,0,0,1,430.62,194.27Zm0-74.8a36.4,36.4,0,1,0,36.4,36.4A36.44,36.44,0,0,0,430.62,119.47Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M417.93,183.11,388.28,166a.59.59,0,0,1,0-1.11l53.1-30.66a2.16,2.16,0,0,1,1.92,0L473,151.34a.59.59,0,0,1,0,1.11l-53.1,30.66A2.16,2.16,0,0,1,417.93,183.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "430.62 173.77 419.55 176.75 393.39 161.65 404.46 158.67 430.62 173.77",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.42 174.81 418.89 178.46 389.13 161.27 402.65 157.62 404.46 158.67 393.39 161.65 419.55 176.75 430.62 173.77 432.42 174.81",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.25 162.31 430.62 173.77 404.46 158.67 417.09 147.21 443.25 162.31",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.25 162.31 430.62 173.77 404.46 158.67 417.09 147.21 443.25 162.31",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.05 163.35 432.42 174.81 430.62 173.77 443.25 162.31 445.05 163.35",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.05 163.35 432.42 174.81 430.62 173.77 443.25 162.31 445.05 163.35",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.09 147.21 404.46 158.67 402.65 157.62 415.28 146.17 417.09 147.21",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.09 147.21 404.46 158.67 402.65 157.62 415.28 146.17 417.09 147.21",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.88 147.95 456.78 158.67 430.62 143.56 442.72 132.85 468.88 147.95",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.88 147.95 456.78 158.67 430.62 143.56 442.72 132.85 468.88 147.95",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.11 147.73 458.58 159.71 456.78 158.67 468.88 147.95 442.72 132.85 430.62 143.56 428.81 142.52 442.34 130.54 472.11 147.73",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.11 147.73 458.58 159.71 456.78 158.67 468.88 147.95 442.72 132.85 430.62 143.56 428.81 142.52 442.34 130.54 472.11 147.73",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.78 158.67 443.25 162.31 417.09 147.21 430.62 143.56 456.78 158.67",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.62 143.56 417.09 147.21 415.28 146.17 428.81 142.52 430.62 143.56",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.58 159.71 445.05 163.35 443.25 162.31 456.78 158.67 458.58 159.71",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.72 132.85 440.54 134.78 441.44 140.44 452.29 138.37 442.72 132.85",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.79,143.28a11.58,11.58,0,0,1-4.4,4.13l-4.77-7.53,2.45-.48Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.84,148.18a13.16,13.16,0,0,1-4.38,1.11,11.07,11.07,0,0,1-1.65-.06l-1.74-8.47,2.78-.54Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,148.9a14.2,14.2,0,0,1-4.6-2.3l-.77-4.78,3.84-.75Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,144c-2.66,4.44-8.67,6.65-11.52,6.51,0,0-.52.08,0,.38l5.41,3.13,8-1.62,5-4.41Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.19 153.88 457.36 154.84 459.62 156.15 462.19 153.88",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.54 146.17 437.83 147.73 430.62 143.56 439.16 136 440.54 146.17",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,157.4l-1.42,1.27-12.63-7.29c-.16-1.14.26-1.93.9-1.57Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.34,150.33l-3-1.73,1.85-1,2,1.18S442.21,149.51,442.34,150.33Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "442.72 132.85 440.54 134.78 441.44 140.44 452.29 138.37 442.72 132.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.79,143.28a11.58,11.58,0,0,1-4.4,4.13l-4.77-7.53,2.45-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.84,148.18a13.16,13.16,0,0,1-4.38,1.11,11.07,11.07,0,0,1-1.65-.06l-1.74-8.47,2.78-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,148.9a14.2,14.2,0,0,1-4.6-2.3l-.77-4.78,3.84-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,144c-2.66,4.44-8.67,6.65-11.52,6.51,0,0-.52.08,0,.38l5.41,3.13,8-1.62,5-4.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.19 153.88 457.36 154.84 459.62 156.15 462.19 153.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.54 146.17 437.83 147.73 430.62 143.56 439.16 136 440.54 146.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,157.4l-1.42,1.27-12.63-7.29c-.16-1.14.26-1.93.9-1.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.34,150.33l-3-1.73,1.85-1,2,1.18S442.21,149.51,442.34,150.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.5 149.97 424.3 151.38 417.09 147.21 422.81 145.67 429.5 149.97",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.6 144.38 426.51 146.32 424.7 145.16 427.6 144.38",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.83 147.73 431.39 149.46 427.91 147.22 427.91 147.22 429.81 143.78 430.62 143.56 437.83 147.73",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.78,158.67l-3.39.91h0c-.12,0-3.41-.43-4.33-.63a2.47,2.47,0,0,1-2-1.33c-.49-.91-2.89-6.24-2.89-6.24Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.95 158.84 432.74 150.33 439.35 148.6 442.34 150.33 445.95 158.84",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.2 158.15 437.83 159.19 425.7 152.18 425.7 152.18 430.84 150.83 442.2 158.15",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.07 161.28 443.25 162.31 439.64 160.23 443.87 159.22 447.07 161.28",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.46 160.37 447.34 159.95 448.75 160.83 450.46 160.37",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "429.5 149.97 424.3 151.38 417.09 147.21 422.81 145.67 429.5 149.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.6 144.38 426.51 146.32 424.7 145.16 427.6 144.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.83 147.73 431.39 149.46 427.91 147.22 427.91 147.22 429.81 143.78 430.62 143.56 437.83 147.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.78,158.67l-3.39.91h0c-.12,0-3.41-.43-4.33-.63a2.47,2.47,0,0,1-2-1.33c-.49-.91-2.89-6.24-2.89-6.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.95 158.84 432.74 150.33 439.35 148.6 442.34 150.33 445.95 158.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.2 158.15 437.83 159.19 425.7 152.18 425.7 152.18 430.84 150.83 442.2 158.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.07 161.28 443.25 162.31 439.64 160.23 443.87 159.22 447.07 161.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.46 160.37 447.34 159.95 448.75 160.83 450.46 160.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "443.25 162.31 438.08 167 432.74 166.48 433.85 162.21 439.64 160.23 443.25 162.31",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.98 155.95 411.24 162.58 404.46 158.67 405.28 157.92 408.5 158 413.98 154.92 418.98 155.95",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.83 159.19 433.32 160.75 422.84 154.69 425.7 152.18 437.83 159.19",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.3 151.38 420.32 154.79 416.77 153.98 417.09 147.21 424.3 151.38",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.37 148.77 415.14 153.69 413.48 153.46 412.79 153.86 412.07 151.76 415.37 148.77",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.16 154.8 408.37 156.41 406.89 156.46 410.58 153.12 411.16 154.8",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.41 161.73 422.5 164.91 415.68 160.98 421.4 155.95 431.41 161.73",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.85 163.02 429.01 172.84 423.23 169.5 423.23 169.5 422.5 166.37 431.85 163.02",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.52 168.41 432.92 171.68 430.91 173.5 432.33 168.04 436.52 168.41",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.75 168.56 421.72 168.63 418.55 166.8 421.14 166.48 421.75 168.56",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.47 165.32 416.93 165.87 416.93 165.87 412.82 163.49 414.48 162.03 420.47 165.32",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "443.25 162.31 438.08 167 432.74 166.48 433.85 162.21 439.64 160.23 443.25 162.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.98 155.95 411.24 162.58 404.46 158.67 405.28 157.92 408.5 158 413.98 154.92 418.98 155.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.83 159.19 433.32 160.75 422.84 154.69 425.7 152.18 437.83 159.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.3 151.38 420.32 154.79 416.77 153.98 417.09 147.21 424.3 151.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.37 148.77 415.14 153.69 413.48 153.46 412.79 153.86 412.07 151.76 415.37 148.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.16 154.8 408.37 156.41 406.89 156.46 410.58 153.12 411.16 154.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.41 161.73 422.5 164.91 415.68 160.98 421.4 155.95 431.41 161.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.85 163.02 429.01 172.84 423.23 169.5 423.23 169.5 422.5 166.37 431.85 163.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.52 168.41 432.92 171.68 430.91 173.5 432.33 168.04 436.52 168.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.75 168.56 421.72 168.63 418.55 166.8 421.14 166.48 421.75 168.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.47 165.32 416.93 165.87 416.93 165.87 412.82 163.49 414.48 162.03 420.47 165.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "404.09 163.42 397.76 164.17 397.76 164.17 393.39 161.65 402.41 159.22 404.09 163.42",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.24 162.58 405.33 163.28 403.56 158.91 404.46 158.67 411.24 162.58",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.93 165.87 408.76 170.52 408.76 170.52 399.5 165.18 412.82 163.49 416.93 165.87",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.01 172.84 427.2 174.69 420.47 176.5 423.23 169.5 429.01 172.84",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.72 168.63 418.63 176.22 410.35 171.44 418.55 166.8 421.72 168.63",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "404.09 163.42 397.76 164.17 397.76 164.17 393.39 161.65 402.41 159.22 404.09 163.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.24 162.58 405.33 163.28 403.56 158.91 404.46 158.67 411.24 162.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.93 165.87 408.76 170.52 408.76 170.52 399.5 165.18 412.82 163.49 416.93 165.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.01 172.84 427.2 174.69 420.47 176.5 423.23 169.5 429.01 172.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.72 168.63 418.63 176.22 410.35 171.44 418.55 166.8 421.72 168.63",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pin--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.85,128.8a2.43,2.43,0,0,0-1.37-.4,4.07,4.07,0,0,0-2,.62,10.86,10.86,0,0,0-4.76,8.61v.74c0,3.24,4.35,6.75,4.35,6.75l1.71,1,0,0c-1.3-1.2-4.13-4.09-4.13-6.58v-.74a9.18,9.18,0,0,1,.48-2.82v0h0a10.5,10.5,0,0,1,4.28-5.77,3.31,3.31,0,0,1,3.13-.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.8,132.67a2.35,2.35,0,0,1,0,.47,5.26,5.26,0,0,1-2.38,4.13,1.89,1.89,0,0,1-.44.2c.2,1.16,1.18,1.57,2.35.9a5.28,5.28,0,0,0,2.38-4.13C434.75,132.89,433.91,132.26,432.8,132.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.13,133.23c0-3.24-2.14-4.63-4.77-3.11a10.88,10.88,0,0,0-4.76,8.61v.74c0,2.49,2.82,5.39,4.12,6.59a.65.65,0,0,0,1-.19c1.12-2.3,4.39-9.22,4.39-11.9Zm-4.77,5.14c-1.31.76-2.38.14-2.38-1.38a5.27,5.27,0,0,1,2.38-4.12c1.32-.76,2.38-.15,2.38,1.37A5.26,5.26,0,0,1,432.36,138.37Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.17,166.12a2.36,2.36,0,1,0,2.35-2.35A2.36,2.36,0,0,0,312.17,166.12Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.58 166.62 314.52 166.62 314.52 165.62 337.23 165.62 350.2 155.37 393.22 155.37 393.22 156.37 350.55 156.37 337.58 166.62",
    style: {
      fill: "#603FEF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 428.48,
    cy: 279.41,
    r: 37.4,
    transform: "translate(-72.07 384.82) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.48,317.81a38.41,38.41,0,1,1,38.4-38.4A38.44,38.44,0,0,1,428.48,317.81Zm0-74.81a36.41,36.41,0,1,0,36.4,36.41A36.44,36.44,0,0,0,428.48,243Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M423.9,309.65l-25.71-14.84a.73.73,0,0,1,0-1.38l34.43-19.88a2.67,2.67,0,0,1,2.4,0l25.71,14.84a.73.73,0,0,1,0,1.38l-34.44,19.88A2.65,2.65,0,0,1,423.9,309.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.92,294.39l.91-.48-.83-.2A.62.62,0,0,0,401.92,294.39Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,294.39l.91-.48-.83-.2A.62.62,0,0,0,401.92,294.39Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.07,306.56a2.08,2.08,0,0,1-1.85,0l-20.82-12,31.16-17.7.73-.42,20.81,11.73a.57.57,0,0,1,0,1.07Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.25,284.15,411,288.33l-4.7-2.72-5.47,3.16v3.65c0,.48.54,1.16.73,1a5.65,5.65,0,0,1,1.05.37,8.43,8.43,0,0,1,1.51,1.12l16.67-9.34Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.25,284.15,411,288.33l-4.7-2.72-5.47,3.16v3.65c0,.48.54,1.16.73,1a5.65,5.65,0,0,1,1.05.37,8.43,8.43,0,0,1,1.51,1.12l16.67-9.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.83,289.21v4l-.06,0a1.87,1.87,0,0,0-.89-.28.94.94,0,0,0-.59.14v-4.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.85,294.53a1.27,1.27,0,0,0-.26-.68,1.75,1.75,0,0,0-.26-.29.3.3,0,0,0-.08-.08l-.12-.1-.09-.07-.21-.14v-3.94l1,.59v4.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.83,292.42c0,.48.54,1.16.73,1h0l.73-.47v-3l-.73-1.26-.4-.14-.33.19Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.14,301.51V306a1.2,1.2,0,0,1-.61-.14l-2.29-1.32-17.39-10V289.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.58,284.54V288A1.38,1.38,0,0,1,455,289L428,304.57l-2.28,1.32a1.23,1.23,0,0,1-.62.14v-4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,271,403.4,289v.42c0,.23-.32.32-.72.08s-.73-.52-.73-.92l0-.39,31.75-18.33.12-.07a.35.35,0,0,1,.06.19v.19C433.84,270.36,434.16,270.74,434.56,271Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,271,403.4,289v.42c0,.23-.32.32-.72.08s-.73-.52-.73-.92l0-.39,31.75-18.33.12-.07a.35.35,0,0,1,.06.19v.19C433.84,270.36,434.16,270.74,434.56,271Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.22,301l-20.36-11.75c-.26-.14-.49-.25-.59-.19l.13-.08,31.16-18,.36-.21a1.15,1.15,0,0,1,1,.15l20.2,11.66a.57.57,0,0,1,0,1.07l-30,17.34A2.08,2.08,0,0,1,424.22,301Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.78,269.75l-.12.07-31.75,18.33a.25.25,0,0,0-.07-.09l-.1-.06-.23-.13-.28-.16a.27.27,0,0,0-.36,0s0,0,0,0a.64.64,0,0,0-.1.13,1.42,1.42,0,0,0-.08.18,1.29,1.29,0,0,0-.06.21,1.69,1.69,0,0,0,0,.24c0,.05,0,.1,0,.15a.41.41,0,0,1,0,.11,2.62,2.62,0,0,0,0,.28v-.89a1.92,1.92,0,0,1,.93-1.43l30-17.34a1.91,1.91,0,0,1,1.65-.12l.38.23h0l.16.1h0A.24.24,0,0,1,433.78,269.75Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.21,306.56l-1.25-.73L404.12,295a1.27,1.27,0,0,0-.26-.68,3,3,0,0,0-.83-.72,1.83,1.83,0,0,0-.88-.28,1,1,0,0,0-.59.19,3.2,3.2,0,0,1-.35-1.55h-.71a2.93,2.93,0,0,0,.73,2.2l.36.21c.2.12.36.12.36,0v-.19c0-.21.32-.2.73,0s.72.59.72.8v.2c0,.11.28.35.62.55l18.22,10.52,2,1.14h0a1.87,1.87,0,0,0,.92.22v-.82A1.91,1.91,0,0,1,424.21,306.56Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.21,306.56l-1.25-.73L404.12,295a1.27,1.27,0,0,0-.26-.68,3,3,0,0,0-.83-.72,1.83,1.83,0,0,0-.88-.28,1,1,0,0,0-.59.19,3.2,3.2,0,0,1-.35-1.55h-.71a2.93,2.93,0,0,0,.73,2.2l.36.21c.2.12.36.12.36,0v-.19c0-.21.32-.2.73,0s.72.59.72.8v.2c0,.11.28.35.62.55l18.22,10.52,2,1.14h0a1.87,1.87,0,0,0,.92.22v-.82A1.91,1.91,0,0,1,424.21,306.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.22,301h0l-1.25-.73-14.48-8.35-4.62-2.67c-.33-.19-.59-.26-.61-.16h0v.21c0,.23-.33.23-.73,0a1,1,0,0,1-.57-.73v-.23a.34.34,0,0,0-.11-.27l-.1-.06-.23-.13-.28-.16a.27.27,0,0,0-.36,0s0,0,0,0a.15.15,0,0,0-.06.09l0,0a1.42,1.42,0,0,0-.08.18,1.29,1.29,0,0,0-.06.21,1.69,1.69,0,0,0,0,.24c0,.05,0,.1,0,.15a.41.41,0,0,1,0,.11,2.62,2.62,0,0,0,0,.28v2.84h.71v-2.84c0-.07,0-.15,0-.22l0-.18v0a2.09,2.09,0,0,0,1.08,1.35,1.86,1.86,0,0,0,.87.27.94.94,0,0,0,.64-.24l.06,0,.13.07,18.22,10.52,2,1.14h0a1.94,1.94,0,0,0,.91.21v-.82A1.87,1.87,0,0,1,424.22,301Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.22,301h0l-1.25-.73-14.48-8.35-4.62-2.67c-.33-.19-.59-.26-.61-.16h0v.21c0,.23-.33.23-.73,0a1,1,0,0,1-.57-.73v-.23a.34.34,0,0,0-.11-.27l-.1-.06-.23-.13-.28-.16a.27.27,0,0,0-.36,0s0,0,0,0a.15.15,0,0,0-.06.09l0,0a1.42,1.42,0,0,0-.08.18,1.29,1.29,0,0,0-.06.21,1.69,1.69,0,0,0,0,.24c0,.05,0,.1,0,.15a.41.41,0,0,1,0,.11,2.62,2.62,0,0,0,0,.28v2.84h.71v-2.84c0-.07,0-.15,0-.22l0-.18v0a2.09,2.09,0,0,0,1.08,1.35,1.86,1.86,0,0,0,.87.27.94.94,0,0,0,.64-.24l.06,0,.13.07,18.22,10.52,2,1.14h0a1.94,1.94,0,0,0,.91.21v-.82A1.87,1.87,0,0,1,424.22,301Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.48,283.09v.84a.65.65,0,0,1-.37.53h0L428,300.67l-2,1.13h0a2,2,0,0,1-.93.21v-.82a1.88,1.88,0,0,0,.93-.22l1.25-.72h0l28.77-16.62A.64.64,0,0,0,456.48,283.09Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.48,283.09v.84a.65.65,0,0,1-.37.53h0L428,300.67l-2,1.13h0a2,2,0,0,1-.93.21v-.82a1.88,1.88,0,0,0,.93-.22l1.25-.72h0l28.77-16.62A.64.64,0,0,0,456.48,283.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.48,288.67v.84a.65.65,0,0,1-.37.53h0L428,306.24l-2,1.14h0a1.88,1.88,0,0,1-.93.22v-.82a1.88,1.88,0,0,0,.93-.22l1.25-.73h0l28.77-16.61A.64.64,0,0,0,456.48,288.67Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.48,288.67v.84a.65.65,0,0,1-.37.53h0L428,306.24l-2,1.14h0a1.88,1.88,0,0,1-.93.22v-.82a1.88,1.88,0,0,0,.93-.22l1.25-.73h0l28.77-16.61A.64.64,0,0,0,456.48,288.67Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.91 285.26 426.25 299.12 458.61 280.55 434.28 266.68 401.91 285.26",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.91 285.26 426.25 299.12 458.61 280.55 434.28 266.68 401.91 285.26",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.47,298.27l-23.64-13.54a7.86,7.86,0,0,0-.11-4.9l23.53,13.43A19.06,19.06,0,0,1,426.47,298.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.28,291.72a4,4,0,0,1,1.82,3.13v3.65c0,1.15-.82,1.62-1.82,1l-23.37-13.38v-.9L425,298.43c.6.35,1.09.07,1.09-.63l0-3.38a2.41,2.41,0,0,0-1.09-1.88l-23.1-13.17v-1Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.28,291.72a4,4,0,0,1,1.82,3.13v3.65c0,1.15-.82,1.62-1.82,1l-23.37-13.38v-.9L425,298.43c.6.35,1.09.07,1.09-.63l0-3.38a2.41,2.41,0,0,0-1.09-1.88l-23.1-13.17v-1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,278.34l32.37-18.57,23.36,13.38a4,4,0,0,1,1.82,3.13v3.65a1.27,1.27,0,0,1-.53,1.17l-32.37,18.57a1.27,1.27,0,0,0,.54-1.17v-3.65a4,4,0,0,0-1.82-3.13Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,278.34l32.37-18.57,23.36,13.38a4,4,0,0,1,1.82,3.13v3.65a1.27,1.27,0,0,1-.53,1.17l-32.37,18.57a1.27,1.27,0,0,0,.54-1.17v-3.65a4,4,0,0,0-1.82-3.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.57,293.07a3.66,3.66,0,0,1,.53,1.78v3.65a1.27,1.27,0,0,1-.54,1.17l32.37-18.57a1.27,1.27,0,0,0,.53-1.17v-3.65a3.66,3.66,0,0,0-.53-1.78Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.57,293.07a3.66,3.66,0,0,1,.53,1.78v3.65a1.27,1.27,0,0,1-.54,1.17l32.37-18.57a1.27,1.27,0,0,0,.53-1.17v-3.65a3.66,3.66,0,0,0-.53-1.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.66,276.92a12.71,12.71,0,0,1,0,6.64l-1.5.87a12.71,12.71,0,0,0,0-6.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.17,289.33a12.81,12.81,0,0,1,0,6.64l-1.51.87a12.71,12.71,0,0,0,0-6.64Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.79,251.34H418.16a1.56,1.56,0,0,0-1.56,1.57v12.64a1.56,1.56,0,0,0,1.56,1.57h7.68l2.05,4.08a.66.66,0,0,0,1.18,0l2-4.08h7.68a1.57,1.57,0,0,0,1.57-1.57V252.91A1.57,1.57,0,0,0,438.79,251.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.52,254.38a3.07,3.07,0,0,0-3,2.65,3.05,3.05,0,0,0-6.08.4c0,3.19,3.23,5.25,4.44,6l1.64,1,1.64-1c1.21-.78,4.44-2.84,4.44-6A3,3,0,0,0,431.52,254.38Z",
    style: {
      fill: "#603FEF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 316.88,
    cy: 185.38,
    r: 2.36,
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.83 256.46 337.68 185.88 316.88 185.88 316.88 184.88 338.14 184.88 399.59 255.81 398.83 256.46",
    style: {
      fill: "#603FEF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puff--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bean-bag--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.62,205.62c-23.07,13.32-56.46,44.84-56.46,101.68s26.86,99.11,78.31,118c16.77,6.16,39.7,8.76,61.47,7.56a121.09,121.09,0,0,0,66.9-24.36c13.78-10.52,23.92-23,30.58-40.29,10.91-32-8.62-65.58-35.19-84.75s-23.4-41-42.18-63.7c-10.09-12.2-25-22.63-43.11-24.65C233.14,192.91,210.18,195.48,192.62,205.62Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.62,205.62c-23.07,13.32-56.46,44.84-56.46,101.68s26.86,99.11,78.31,118c17.36,6.37,41.31,8.93,63.74,7.42A119.68,119.68,0,0,0,340.84,410c14.8-10.83,25.6-23.63,32.58-41.78,10.91-32-8.62-65.58-35.19-84.75s-23.4-41-42.18-63.7c-10.09-12.2-25-22.63-43.11-24.65C233.14,192.91,210.18,195.48,192.62,205.62Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,432.78l2-.13a121.32,121.32,0,0,0,18.71-2.88c-31.6,2.68-64.22-5.5-90.07-23.08-41.4-28.16-59.32-72.81-50.46-125.72,7.83-46.73,31.2-72.46,54.65-83.1-1.31.35-2.6.72-3.89,1.12h0c-1.27.4-2.52.83-3.76,1.28l-.08,0c-1.24.46-2.46.94-3.66,1.45l-.08,0c-1.22.52-2.43,1.07-3.61,1.65h0c-19,13.86-35.89,38.5-42.35,77.06-9.06,54.07,9.29,99.72,51.67,128.55,20.56,14,45.32,22.13,70.51,23.76Z",
    style: {
      fill: "#603FEF",
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.28,339c.4-30.51-5.45-29.25-38.68-48.56-16.91-9.83-20-9.63-34.81-48.22s-42-35.67-42-35.67-39.79,1.35-49.29,29.71c-6.57,19.57-6.43,58.17-.24,79,3.71,12.48,8.79,18.38,8.79,18.38C184.54,329.79,169,343,169,343s14-5.36,42.66-.05c19.79,3.66,18.35,9.72,50.35,9.72,15.1,0,5,10.24,25.77,20.9,5.55,2.86,8.88,13.7,17.51,19.22a46.8,46.8,0,0,0,18,6.6l4.3,19h0A116.61,116.61,0,0,0,340.84,410a98.26,98.26,0,0,0,19.38-18.35C360.54,379.88,360.09,353.22,360.28,339Z",
    style: {
      fill: "#603FEF",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.26,182.1c8.07.13,10.65,1.35,24.83,6.49,16.57,6,28.1,9.62,28.1,9.62l17.5-34.47c2.72-5.81,4.72-9.67,9.63-13.81a15.3,15.3,0,0,1,7-1.82c7.53.28,22.14,8,14.47,15.51-4.56,4.46-6.82,7.32-12.24,10-2.44,1.19-6.05,1.72-7,4.47-4.34,12-9.69,31.41-12,36.78-3.69,8.61-7,8.61-15.48,7-10.95-2.08-46.2-10.29-46.2-10.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.19,198.21c-1.82,4-1.93,9.32-1.71,11.88,0,0-2.58-3.84-1.12-12.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.87,158.07l13.67,6.78L357.42,166l-13-6.08s-3.9,0-5.36,1.88C338.08,157.41,344.87,158.07,344.87,158.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,160.29a11.35,11.35,0,0,1-3.36,9s4.27-1.31,5.24-8.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369,162.46l6.81,6.83a.29.29,0,0,1-.24.5l-9.62-1.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,169.79a.29.29,0,0,0,.24-.5L374.45,168h0a1.6,1.6,0,0,1-.83,1.48l-.14.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,150.44l.8.4,1,.48,34.7,17.18a4.29,4.29,0,0,0,2.46-2c.88-1.39,1.14-3.13.59-4.07l-34.68-17.17-1.84-.91C333.61,145,330.63,151.08,329.46,150.44Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,150.44l.8.4,1,.48,34.7,17.18a4.29,4.29,0,0,0,2.46-2c.88-1.39,1.14-3.13.59-4.07l-34.68-17.17-1.84-.91C333.61,145,330.63,151.08,329.46,150.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.5,152l1.79.88c.51.27,1.38-.67,2.13-1.88,1-1.62,1.51-3.84.84-4.2l-1.32-.65-.47-.23c.67.36.15,2.58-.84,4.2-.72,1.17-1.56,2.08-2.07,1.9h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,152.18c1.18.63,4.15-5.45,3-6.08l-1.79-.89c1.18.63-1.79,6.71-3,6.08Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,150.44l1.76.88c1.16.63,4.07-5.21,3.07-6a.09.09,0,0,0-.06,0l-1.78-.87C333.61,145,330.63,151.08,329.46,150.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,169.65l-.05-.36-6.94-3.62-36.7-18.16c.05-.11,0-.16-.06-.16-.74,1.71-2,3.45-2.62,3.09l.8.4,1,.48,34.7,17.18h0l9.62,1.29A.31.31,0,0,0,375.83,169.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,146.72l7.49,3.72c.5.28,1.37-.65,2.12-1.85,1-1.62,1.53-3.84.87-4.21h0l-7.51-3.73c-1.5-.73-3.37,2.12-3.64,4.24A1.74,1.74,0,0,0,322,146.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,145.83a5.24,5.24,0,0,0,1.33-4.45,1.17,1.17,0,0,0-.73-.82c-1.45-.35-3.13,2.31-3.39,4.32a1.74,1.74,0,0,0,.65,1.82C322.5,147,323.32,146.68,324.08,145.83Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.29,148.73a18.08,18.08,0,0,1,2.8-1.95,12.17,12.17,0,0,1,4.77-1.7,3.88,3.88,0,0,1,1.92.18,5.75,5.75,0,0,1,1.58,1.2c2.55,2.36,6,2.19,8.47,4.49a67.81,67.81,0,0,1,4.46,6.94,24.76,24.76,0,0,0,1.47,2.21c.14,1-.7,1.16-1.33,1.2a4,4,0,0,1-2.82-1.37c-.4-.35-1.33-1.28-1.33-1.28.17.72-.23,1.18-1.07,1.4-1,.27-2.3-.78-3.06-1.48-1.84-1.71-2.39-2.75-3.81-3.85l-2.58-1.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1,161.18a3.89,3.89,0,0,1-2.84-1.45,21,21,0,0,1-3-5,10.3,10.3,0,0,0-2.8-3.9c-1.15-.81-3.42-2.76-3.42-2.76l1.94,2a16.36,16.36,0,0,1,3,4.1c.55,1.23,1.48,3,2.3,4.47,0,0,.93.93,1.33,1.28a4,4,0,0,0,2.82,1.37A2.2,2.2,0,0,0,366.1,161.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,150.1s1.15.13,1.56,1.89a2.67,2.67,0,0,1-.07,1.89l-.87-.44Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69,163.74c2.25-4.69,2.29-8.79,6.5-10.8,2.76-1.3,5.54-1.16,10.71-1.91,1.85-.26,4.07-1.06,4.24-.93,2.3,1.8.38,5.21-3.92,7.42-2.18,1.11-6.52,1.58-7.14,4.25a9.72,9.72,0,0,1-.62,7.1S333,169.73,328.69,163.74Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224,173c-1.56-5.15-6.35-8.42-11.81-14.57-8.52-9.59-10.14-25.8,1.42-33.2,3.7-18.69,24.68-21.5,37.89-17.68,16.37,4.73,22,19.42,15.57,31.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18,146.6c2.14-2.53,5.46-2.95,7.86-.4a8.43,8.43,0,0,1,1.76,3.19c.5,1.39,1.55,2,2.55,1.33,3.78-2.34,2.21-11,1.9-14.3,5.38-2.66,7.36-7,8-12,2.74,1.28,8.08,2.06,12.33,2.4s10.91-.24,16.18-4.19a27.55,27.55,0,0,1,4,7.33c1.93,5.68,2.11,11.94,2,17.88,0,.17,0,.33,0,.5-.44,16.38-4.49,23.21-9.08,25.5-2.83,1.41-6.22,1.87-11.7,1.38l.15,9.32s7.32,5.92,3.63,14.48c0,0-8.56-.93-15.3-4.14-10.9-5.18-12-10.07-12-10.07l-.73-25.68s-2.33,3.24-7.51.4C212.27,157.4,209,150.4,212.18,146.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,126.31c-3.77,2.18-11,10.59-11.38,23.65a27.79,27.79,0,0,1,.81-14.46,26.88,26.88,0,0,1,7.54-12.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,144.38a2.25,2.25,0,0,1-1.93,2.45,2.12,2.12,0,0,1-2.41-1.85,2.25,2.25,0,0,1,1.93-2.45A2.11,2.11,0,0,1,245.49,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,135.24l-5.47-1.86a2.78,2.78,0,0,1,3.57-1.86A3,3,0,0,1,265.27,135.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.57,134.2l-5.35,2.19a2.78,2.78,0,0,1,1.47-3.75A3,3,0,0,1,243.57,134.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,158.82l9.45,3a5,5,0,0,1-6.69,3C245.06,164,244.14,161.49,244.88,158.82Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37,165.17a5.2,5.2,0,0,0-5.25-4.62c-.16,0-.32,0-.48,0a4.37,4.37,0,0,0,3,4.29A5.64,5.64,0,0,0,250.37,165.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,143.4a2.25,2.25,0,0,1-1.93,2.45,2.11,2.11,0,0,1-2.4-1.85,2.24,2.24,0,0,1,1.92-2.45A2.11,2.11,0,0,1,264.27,143.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9,175.19c-5.78-.76-17.5-4.71-19.68-9.2a11.47,11.47,0,0,0,4.33,6.9c5.07,3.75,15.37,5.3,15.37,5.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,138.11l-17.58,6.48a6.18,6.18,0,0,1,3.21,2.33l14.47-5.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.9,136.73l-1-.09c-3.35-.22-7.72-.14-10.35.79-3.3,1.17-4.46,2.36-6.29,2.45s-3.2-1-6.73-1.89c-2.82-.69-7.5-.38-11.07.14-.39.06-.76.11-1.12.18a1.86,1.86,0,0,0-1.22,1.92,4.14,4.14,0,0,0,1.08,2.13,2.48,2.48,0,0,1,.37.87c.39,1.49.64,4.37,1.39,6a7.26,7.26,0,0,0,1.43,2.1,6.21,6.21,0,0,0,.73.61,4.28,4.28,0,0,0,.42.26,5.66,5.66,0,0,0,1.24.55.83.83,0,0,0,.21.06l.33.09.35.07a9,9,0,0,0,1.1.13l.47,0h.59c4.54-.18,6.43-2.47,7.54-4.79s.8-5.54,2.9-5.62h.2l.18,0c1.56.31,1.39,3.27,2.37,5.35a8.4,8.4,0,0,0,1.5,2.26l.36.35.19.16.2.15.18.13.2.13a1.19,1.19,0,0,0,.15.09l.11.07a6.42,6.42,0,0,0,1.82.66.86.86,0,0,0,.17,0,9,9,0,0,0,2.21.14,6.67,6.67,0,0,0,6.39-4.45c.69-1.64.93-4.54,1.26-6.07a1.92,1.92,0,0,1,.39-.81,4.41,4.41,0,0,0,.94-2.26C273.1,137.63,272.47,136.78,271.9,136.73Zm-21.76,9.44a7,7,0,0,1-1.56,3.24h0a6.5,6.5,0,0,1-4.94,2,5.31,5.31,0,0,1-4.78-2.11,1.43,1.43,0,0,1-.15-.22,2,2,0,0,1-.14-.22,1.13,1.13,0,0,1-.12-.21,1.14,1.14,0,0,1-.1-.19l-.07-.14s-.05-.1-.07-.14l-.1-.22h0c-.09-.22-.17-.44-.24-.65v0a3.43,3.43,0,0,1-.12-.39c-.07-.23-.12-.45-.16-.64l0-.12,0-.12c-.36-1.58-.8-4.69,0-5.43s2.84-1.56,6.23-1.37l.36,0a13.26,13.26,0,0,1,1.54.21l.6.12a11.72,11.72,0,0,1,1.51.44l.47.17.5.23.1,0,.18.1a3,3,0,0,1,1,.79C250.7,142.31,250.51,144.38,250.14,146.17Zm19.73-1.52c-.25,1.25-.8,4-3.16,5.24a5.86,5.86,0,0,1-2.51.66,5.3,5.3,0,0,1-5.08-2.16v0l-.1-.14c0-.06-.07-.11-.1-.16l-.05-.09c-.05-.08-.09-.17-.13-.25a2.59,2.59,0,0,1-.14-.29l-.06-.14,0-.08-.05-.11a.54.54,0,0,1,0-.1,7.39,7.39,0,0,1-.34-1.17c-.36-1.76-.55-3.81.08-4.82s3.12-2.18,5.52-2.59c.55-.09,1.07-.15,1.55-.18h1.38l.42,0c.28,0,.54.06.78.1l.19,0h0l.13,0,.19.05.22.07a3.19,3.19,0,0,1,.37.13l.06,0a2.9,2.9,0,0,1,.84.5C270.58,139.89,270.19,143,269.87,144.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.45,142.88l1,13.15,8-2.55-7.83-10.81A1.72,1.72,0,0,0,253.45,142.88Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.36,235.06c.12,8.28,3.24,35.06,3.24,35.06-24.29,18.55-64.33,7.22-64.33,7.22,1.83-6.33,1.38-14.24.56-20L204,229.69a90.32,90.32,0,0,0,5.18-41.87l28.09-8.1,20.5,2.51s7.29,11.75,13.65,21.24C279.2,215,280,226.37,273.36,235.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.73,230.79c7.73-10.91,3.94-21.37-3.09-29.07-4.14-4.53-17.38-19.61-17.38-19.61l-7.64-.63c4.85,6.15,10.22,13.5,12.74,19.2-2.85,3.66-6.78,10.21-9.39,20.73,0,0-8.43-12.17-27.95-17-4.25-9.1-8-19.11-8-19.11l-4.68,1.3s4.8,17.88,2.48,32.81c-1.93,12.43-9.7,16.94-9.7,16.94.6,5.43,4.34,16.63,4,24.65-.26,6.66-1.39,13.26-2.37,28a103,103,0,0,0,0,13,150.23,150.23,0,0,1,21.15-1.8s8.43,13,30.11,11.31c24.66-2,28.46-15,28.46-15L279,260.08Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.11,153.91c-1.31,2.59-4,9.34,2.2,17.88,0,0-3.26,2.08-2.24,7.47a12.18,12.18,0,0,0,4.37,6.88s-2.08,3.36-.12,8.23c1.74,4.32,6.6,6.14,6.6,6.14a7.32,7.32,0,0,0,2,6.78,16.06,16.06,0,0,0,7.7,4.3,7.94,7.94,0,0,0,2.48,6.93c3.85,3.84,7,3.54,7,3.54a7.23,7.23,0,0,0,.75,7.09,6.24,6.24,0,0,1,.39,7.06A12.73,12.73,0,0,0,247.4,225c.33-5.61-3.71-6.4-3.71-6.4s.08-5.25-2.08-8c-2.47-3.11-4.22-3.11-4.22-3.11a12.53,12.53,0,0,0-2-7.51c-2.34-3.36-5-3.67-5-3.67a18,18,0,0,0-.84-7.44c-1.53-3.75-3.69-4.29-3.69-4.29a10.74,10.74,0,0,0-1.56-12.26,8.72,8.72,0,0,0,.48-4.09c-.21-3.38-.82-2.81-1.12-7.1C218.76,163.83,213.51,159,209.11,153.91Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.83,364.67s1.08,36.76,3.31,49.58c4,8.17,7.1,11.62,12.54,17.78,1.19,1.34,3.88,3.83,4.85,4.92a2.12,2.12,0,0,1-.19,3.26c-2.36,2.31-12.5,3-18.22-1.23s-11-13.22-14.43-16.61c-1.28-1.28-2.5-2.58-3.65-4s-.83-2.62-.94-4.13c-.06-.72,0-2.72,0-2.72-.82-3.55-10.05-33.91-11.21-37.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.92,427.66a8.24,8.24,0,0,0,.31,2.76c.62,1.47,6.15,4.62,8.25,5.73s4.39,2.65,6.3,7c2,4.68,6.21,8.11,11,10.45a35,35,0,0,0,20.65,2.66c8.69-1.35,9.52-6.43,9.52-6.43s.58-4.79-1.56-5.61S336.92,427.66,336.92,427.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,409.35c-.24.11-.67.24-.92,1.24-.09.38.18,4.45-.1,6.79-.3,2.51-1.64,7.2-.62,10.28,4.48,4.76,11.63,6.11,15,11s6.43,11,17.72,13.55,20-.86,22.15-4,.34-6.26-6.83-10.37c-7.61-4.35-17.46-17-17.46-17a51,51,0,0,1-3.7-5.63c-1.09-1.86-1.53-4.19-2.32-6.21a5,5,0,0,0-1.69-2.51,5.13,5.13,0,0,0-3-.46,22.78,22.78,0,0,0-4.87.61,7.45,7.45,0,0,0-4.05,2.62c-.7,1-1.07,2.13-1.86,3a4.26,4.26,0,0,1-4.34,1.22,3.67,3.67,0,0,1-2.87-3.14A10.13,10.13,0,0,1,338.56,409.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.35,449.35s0-7.94,8.7-12.1,13.78-1.22,16.35.73c3.06,2.32,7.4,7.11,4.61,10.44-3,3.6-7.73,5.23-16.46,5.12S362.35,449.35,362.35,449.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.29,422.55a1,1,0,0,0,.79-.38c1-1.33,7.35-6.24,13.32-4.42.32-.68-.16-1.41-1.38-2.18-6.3-.72-12.32,3.89-13.53,5.49a.91.91,0,0,0,.22,1.31A1,1,0,0,0,351.29,422.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73,422.36a3,3,0,0,0-1.65-2.13c-6-.28-11.59,4-12.75,5.56a.95.95,0,0,0,.81,1.49,1,1,0,0,0,.78-.38C356.9,425.61,362.92,421,368.73,422.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.92,432.33a5.5,5.5,0,0,0-2.62-2.6c-6.2-.56-12.08,3.94-13.28,5.53a.91.91,0,0,0,.22,1.31,1,1,0,0,0,.59.18,1,1,0,0,0,.78-.39C364.67,435,371.69,429.58,377.92,432.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,432a1,1,0,0,0,.79-.39c1-1.31,7.21-6.11,13.12-4.46a3.35,3.35,0,0,0-2-2.21c-6-.27-11.58,4-12.75,5.56a.93.93,0,0,0,.23,1.32A1,1,0,0,0,359,432Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,323c13.34,9.94,55.3,15.46,66.47,20.12a52.42,52.42,0,0,0,1.77,18.73c2.13,7.55,7.86,23.5,7.86,23.5s15.87,4.28,25.39-6.34c-1-27.26-1.26-30.23-2.5-49.73-.57-9.09-4.51-13-11.22-17-11.93-7.13-58.27-30.28-58.27-30.28s-26.11-.2-45.56,11.25C241.48,309.8,247.16,317.09,255.13,323Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.07,293.3c2.41,16.5,8.09,23.79,16.06,29.74,13.34,9.94,55.3,15.46,66.47,20.12L287.87,327.4s3.07-22.38,2-42.3c0-.19,0-.36,0-.54-3.22-1.56-5.22-2.51-5.22-2.51S258.52,281.85,239.07,293.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.34,381.69a5.61,5.61,0,0,1-2.35,3.17c-2.6,1.83-6,2.1-9.15,2a30.21,30.21,0,0,1-8.91-1.45,17,17,0,0,1-7.48-4.92,38.17,38.17,0,0,1-3.74-6.13,18.6,18.6,0,0,0-3.26-4.51,20.31,20.31,0,0,0-2-1.4c-.77-.58-1.51-1.21-2.29-1.78-2-1.43-4.14-2.72-5.47-4.76-2.31-3.56-1.32-7.86-.95-11.79q.14-1.44.3-2.88l-.1-1.53c-.34-7.53-4.83-32.09-5.76-36.81l27-.39c-.68,9-1.71,27.68-1.5,34a29.87,29.87,0,0,0,1,7.59c1.25,4.16,3.82,8.15,6.38,11.62a68.15,68.15,0,0,0,5.76,6.71,21.88,21.88,0,0,0,3.26,2.56,71.74,71.74,0,0,1,6.78,4.71C334.54,377.16,335.87,379.43,335.34,381.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,363.59a8.1,8.1,0,0,0,.17,2.74c.55,1.47,5.85,4.84,7.87,6s4.21,2.82,5.89,7.23c1.79,4.7,5.74,8.29,10.36,10.82A34.57,34.57,0,0,0,332.05,394c8.64-.91,9.69-5.89,9.69-5.89s.79-4.7-1.28-5.6S287.52,363.59,287.52,363.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,345.17c-1,0-1.27.49-1.21,1.47a48.8,48.8,0,0,1-.37,6.84c-.42,2.46-1.68,7-.81,10.11,4.19,4.9,11.18,6.57,14.27,11.57s5.82,11.17,16.84,14.19,19.74.09,22-2.94.63-6.16-6.25-10.54c-7.3-4.65-16.42-17.6-16.43-17.61a50.39,50.39,0,0,1-3.38-5.71c-1-1.89-1.31-4.21-2-6.24a4.87,4.87,0,0,0-1.55-2.55,5,5,0,0,0-2.92-.6,22.24,22.24,0,0,0-4.83.38,7.22,7.22,0,0,0-4.12,2.39c-.73.91-1.16,2.05-2,2.89a4.25,4.25,0,0,1-4.34,1,4.92,4.92,0,0,1-2.84-3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,386.17s.42-7.83,9.15-11.53,13.65-.56,16.09,1.49c2.91,2.43,7,7.36,4.06,10.51-3.14,3.41-7.87,4.8-16.47,4.28S311.58,386.17,311.58,386.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93,359.22a1,1,0,0,0,.8-.34c1-1.27,7.54-5.81,13.34-3.73.35-.66-.1-1.41-1.26-2.22-6.18-1-12.34,3.26-13.61,4.78a.91.91,0,0,0,.16,1.31A1,1,0,0,0,301.93,359.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.14,359.85a3,3,0,0,0-1.53-2.19c-5.9-.55-11.62,3.44-12.84,4.9a.9.9,0,0,0,.16,1.3,1,1,0,0,0,.57.21,1,1,0,0,0,.8-.35C307.32,362.5,313.48,358.2,319.14,359.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.74,370.11a5.38,5.38,0,0,0-2.47-2.68c-6.09-.85-12.1,3.32-13.35,4.82a.9.9,0,0,0,.15,1.31,1,1,0,0,0,1.37-.14C314.55,372.08,321.72,367.11,327.74,370.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,368.91a1,1,0,0,0,.8-.34c1-1.25,7.4-5.69,13.14-3.79a3.29,3.29,0,0,0-1.83-2.27c-5.91-.55-11.62,3.43-12.84,4.9a.9.9,0,0,0,.16,1.3A.94.94,0,0,0,309.07,368.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,315.17c9.18,18.63,32.33,21.82,46.93,15.58,25.86-11.06,50.6-71.82,49.33-86.37-1.28-14.71-16.08-19.16-42.05,1.36-13.94,11-22.88,21.4-33.61,37-4.36,1.46-19.34,9.39-23.67,19.33A37.4,37.4,0,0,0,210.91,315.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.25,250.25c-5,4.75-11.33,32.95-12.57,48.45-1,13.13-7.39,24.13-23.64,28-15.39,3.64-27.64-.72-32.72-6.05,10.4,13.86,30.58,15.65,43.52,10.12,16.74-7.16,33-35.15,42.06-57.95Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.44,232.67c7.58,2.9,14.8,13,13.72,38.33-1.1,25.69-1.74,44.27-1.74,44.27a37.71,37.71,0,0,1-25.73,3s-2.34-9.67-4.88-23.74-4.16-28.32,1-41.11S299.44,232.67,299.44,232.67Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebooks--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "166.53 251.95 167.06 252.26 167.54 252.54 184.07 262.08 223.77 285 223.77 337.52 224.11 337.33 224.1 284.81 167.54 252.16 167.06 251.88 166.86 251.76 166.53 251.95",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.53 251.95 167.06 252.26 167.54 252.54 184.07 262.08 223.77 285 223.77 337.52 224.11 337.33 224.1 284.81 167.54 252.16 167.06 251.88 166.86 251.76 166.53 251.95",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.53,252v52.53l.53.3.48.28,54.54,31.49,1.36.78.33.19V285l-39.7-22.93-16.53-9.54-.48-.28Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.86 251.76 166.53 251.95 223.77 285 224.1 284.81 166.86 251.76",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.86 251.76 166.53 251.95 223.77 285 224.1 284.81 166.86 251.76",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.94 254 220.51 286.66 220.51 339.02 223.34 337.39 223.34 285.03 166.77 252.37 163.94 254",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.77 252.37 163.94 254 220.51 286.66 223.34 285.03 166.77 252.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.21 253.87 163.74 254.18 164.22 254.46 180.75 264 220.45 286.92 220.45 339.44 220.79 339.24 220.78 286.73 164.22 254.08 163.74 253.79 163.54 253.68 163.21 253.87",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.21 253.87 163.74 254.18 164.22 254.46 180.75 264 220.45 286.92 220.45 339.44 220.79 339.24 220.78 286.73 164.22 254.08 163.74 253.79 163.54 253.68 163.21 253.87",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,253.87v52.52l.53.31.48.28,54.54,31.49,1.36.78.33.19V286.92L180.75,264l-16.53-9.54-.48-.28Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.54 253.68 163.21 253.87 220.45 286.92 220.78 286.73 163.54 253.68",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.54 253.68 163.21 253.87 220.45 286.92 220.78 286.73 163.54 253.68",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.79,286.89c-.39-.23-.71-.05-.71.41a1.55,1.55,0,0,0,.71,1.22c.39.23.71,0,.71-.41A1.55,1.55,0,0,0,217.79,286.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.78,281.24a2.06,2.06,0,0,1,2.08-.17,2,2,0,0,1,.88,1.88,4.42,4.42,0,0,1-.12,1l-.48-.28a3.63,3.63,0,0,0,.08-.73A1.31,1.31,0,0,0,220,281.7a5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.25,1.25,0,0,0,.42.46l.05,0a1.61,1.61,0,0,1,.22.61,1.39,1.39,0,0,1-.53-.18,1.64,1.64,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,219.78,281.24Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.35,284.9c-.39-.22-.71,0-.71.41a1.61,1.61,0,0,0,.71,1.23c.39.22.71,0,.71-.41A1.59,1.59,0,0,0,214.35,284.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,279.26a1.82,1.82,0,0,1,3,1.71,4.4,4.4,0,0,1-.12,1l-.47-.27a3.68,3.68,0,0,0,.07-.73,1.56,1.56,0,0,0-.62-1.44,1.6,1.6,0,0,0-1.56.18,5.41,5.41,0,0,0-2.43,4.23,2.12,2.12,0,0,0,.19,1,1.13,1.13,0,0,0,.43.46l0,0a1.46,1.46,0,0,1,.22.61,1.61,1.61,0,0,1-.52-.18,1.74,1.74,0,0,1-.74-.93,3.12,3.12,0,0,1-.15-1A6,6,0,0,1,216.34,279.26Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.92,282.92c-.39-.23-.71,0-.71.41a1.55,1.55,0,0,0,.71,1.22c.39.23.7.05.7-.4A1.56,1.56,0,0,0,210.92,282.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,277.28a2,2,0,0,1,2.07-.18,2.06,2.06,0,0,1,.89,1.89,4.43,4.43,0,0,1-.13,1l-.47-.27a3.79,3.79,0,0,0,.08-.73,1.57,1.57,0,0,0-.63-1.44,1.55,1.55,0,0,0-1.55.18,5.37,5.37,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.17,1.17,0,0,0,.42.46l0,0a1.61,1.61,0,0,1,.23.62,1.4,1.4,0,0,1-.53-.19,1.61,1.61,0,0,1-.73-.93,2.8,2.8,0,0,1-.15-1A6,6,0,0,1,212.91,277.28Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48,280.94c-.39-.23-.71-.05-.71.4a1.57,1.57,0,0,0,.71,1.23c.39.23.71,0,.71-.41A1.55,1.55,0,0,0,207.48,280.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,275.29a1.82,1.82,0,0,1,3,1.71,4.49,4.49,0,0,1-.12,1l-.47-.28a4.51,4.51,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.25,5.4,5.4,0,0,0-2.44,4.22,2.12,2.12,0,0,0,.2,1,1.16,1.16,0,0,0,.43.47l0,0a1.46,1.46,0,0,1,.22.61,1.66,1.66,0,0,1-.53-.18,1.72,1.72,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,209.47,275.29Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,279c-.39-.22-.7,0-.7.41a1.57,1.57,0,0,0,.7,1.23c.39.22.71,0,.71-.41A1.59,1.59,0,0,0,204,279Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,273.31a2,2,0,0,1,2.07-.18A2.06,2.06,0,0,1,209,275a4.43,4.43,0,0,1-.13,1l-.47-.27a3.68,3.68,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.39,5.39,0,0,0-2.44,4.23,2.15,2.15,0,0,0,.2,1,1.11,1.11,0,0,0,.42.46l0,0a1.5,1.5,0,0,1,.22.62,1.42,1.42,0,0,1-.52-.19,1.62,1.62,0,0,1-.73-.92,2.89,2.89,0,0,1-.15-1A6,6,0,0,1,206,273.31Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.61,277c-.39-.23-.71,0-.71.41a1.55,1.55,0,0,0,.71,1.22c.39.23.71,0,.71-.41A1.55,1.55,0,0,0,200.61,277Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.6,271.33a1.82,1.82,0,0,1,3,1.71,4.4,4.4,0,0,1-.12,1l-.48-.27A3.79,3.79,0,0,0,205,273a1.31,1.31,0,0,0-2.18-1.26,5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.17,1.17,0,0,0,.42.46l.05,0a.34.34,0,1,1-.31.43,1.65,1.65,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,202.6,271.33Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.17,275c-.39-.22-.7,0-.7.41a1.57,1.57,0,0,0,.7,1.23c.39.22.71,0,.71-.41A1.59,1.59,0,0,0,197.17,275Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.16,269.34a1.82,1.82,0,0,1,3,1.71,4.34,4.34,0,0,1-.12,1l-.47-.27a3.68,3.68,0,0,0,.07-.73,1.57,1.57,0,0,0-.62-1.44,1.6,1.6,0,0,0-1.56.18A5.41,5.41,0,0,0,197,274a2.12,2.12,0,0,0,.19,1,1.07,1.07,0,0,0,.43.46l0,0a1.46,1.46,0,0,1,.22.61,1.61,1.61,0,0,1-.52-.18,1.74,1.74,0,0,1-.74-.93,3.12,3.12,0,0,1-.15-1A6,6,0,0,1,199.16,269.34Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74,273c-.39-.22-.71,0-.71.41a1.55,1.55,0,0,0,.71,1.22c.39.23.7.05.7-.4A1.57,1.57,0,0,0,193.74,273Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,267.36a2,2,0,0,1,2.08-.18,2.07,2.07,0,0,1,.88,1.89,4.43,4.43,0,0,1-.13,1l-.47-.27a3.79,3.79,0,0,0,.08-.73,1.57,1.57,0,0,0-.63-1.44,1.55,1.55,0,0,0-1.55.18,5.39,5.39,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.11,1.11,0,0,0,.42.46l0,0a1.61,1.61,0,0,1,.23.62,1.4,1.4,0,0,1-.53-.19,1.61,1.61,0,0,1-.73-.93,2.8,2.8,0,0,1-.15-1A6,6,0,0,1,195.73,267.36Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.3,271c-.39-.23-.71,0-.71.41a1.55,1.55,0,0,0,.71,1.22c.39.23.71,0,.71-.41A1.55,1.55,0,0,0,190.3,271Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.29,265.37a2.09,2.09,0,0,1,2.08-.18,2,2,0,0,1,.88,1.89,4.42,4.42,0,0,1-.12,1l-.47-.28a3.61,3.61,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.25,5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.19,1.19,0,0,0,.43.46l0,0a1.46,1.46,0,0,1,.22.61,1.53,1.53,0,0,1-.52-.18,1.66,1.66,0,0,1-.74-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,192.29,265.37Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86,269c-.39-.22-.7,0-.7.41a1.57,1.57,0,0,0,.7,1.23c.4.22.71,0,.71-.41A1.56,1.56,0,0,0,186.86,269Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,263.39a1.82,1.82,0,0,1,3,1.71,4.43,4.43,0,0,1-.13,1l-.47-.27a3.68,3.68,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.39,5.39,0,0,0-2.44,4.23,2.15,2.15,0,0,0,.2,1,1.11,1.11,0,0,0,.42.46l0,0a.34.34,0,1,1-.3.43,1.68,1.68,0,0,1-.73-.93,2.89,2.89,0,0,1-.15-1A6,6,0,0,1,188.86,263.39Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43,267.05c-.39-.23-.71,0-.71.41a1.55,1.55,0,0,0,.71,1.22c.39.23.71.05.71-.41A1.57,1.57,0,0,0,183.43,267.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,261.41a1.82,1.82,0,0,1,3,1.71,4.4,4.4,0,0,1-.12,1l-.48-.27a3.79,3.79,0,0,0,.08-.73,1.31,1.31,0,0,0-2.18-1.26,5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.18,1.18,0,0,0,.42.46l0,0a1.59,1.59,0,0,1,.22.62,1.68,1.68,0,0,1-.53-.19,1.64,1.64,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,185.42,261.41Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,265.07c-.39-.23-.71-.05-.71.4a1.57,1.57,0,0,0,.71,1.23c.39.23.7,0,.7-.41A1.54,1.54,0,0,0,180,265.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,259.42a1.82,1.82,0,0,1,3,1.71,4.44,4.44,0,0,1-.13,1l-.47-.28a3.63,3.63,0,0,0,.08-.73,1.59,1.59,0,0,0-.63-1.44,1.56,1.56,0,0,0-1.55.19,5.37,5.37,0,0,0-2.44,4.22,2.12,2.12,0,0,0,.2,1,1.14,1.14,0,0,0,.42.47l0,0a1.63,1.63,0,0,1,.23.61,1.58,1.58,0,0,1-.53-.18,1.68,1.68,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,182,259.42Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.56,263.08c-.39-.22-.71,0-.71.41a1.59,1.59,0,0,0,.71,1.23c.39.22.71,0,.71-.41A1.59,1.59,0,0,0,176.56,263.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,257.44a1.82,1.82,0,0,1,3,1.71,4.4,4.4,0,0,1-.12,1l-.47-.27a3.68,3.68,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.26,5.42,5.42,0,0,0-2.44,4.23,2.18,2.18,0,0,0,.2,1,1.13,1.13,0,0,0,.43.46l0,0a1.5,1.5,0,0,1,.22.62,1.53,1.53,0,0,1-.52-.18,1.74,1.74,0,0,1-.74-.93,2.89,2.89,0,0,1-.15-1A6,6,0,0,1,178.55,257.44Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.12,261.1c-.39-.23-.7,0-.7.41a1.54,1.54,0,0,0,.7,1.22c.4.23.71,0,.71-.41A1.53,1.53,0,0,0,173.12,261.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.12,255.46a2,2,0,0,1,2.07-.18,2,2,0,0,1,.89,1.89,4.43,4.43,0,0,1-.13,1l-.47-.27a3.75,3.75,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.37,5.37,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.17,1.17,0,0,0,.42.46l0,0a1.45,1.45,0,0,1,.22.62,1.63,1.63,0,0,1-.52-.19,1.61,1.61,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,175.12,255.46Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.69,259.11c-.39-.22-.71,0-.71.41a1.59,1.59,0,0,0,.71,1.23c.39.22.71,0,.71-.41A1.59,1.59,0,0,0,169.69,259.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.68,253.47a1.82,1.82,0,0,1,3,1.71,4.49,4.49,0,0,1-.12,1l-.48-.28a3.71,3.71,0,0,0,.08-.73,1.57,1.57,0,0,0-.62-1.44,1.59,1.59,0,0,0-1.56.18,5.42,5.42,0,0,0-2.44,4.23,2.12,2.12,0,0,0,.2,1,1,1,0,0,0,.42.46l0,0a1.61,1.61,0,0,1,.22.61,1.58,1.58,0,0,1-.53-.18,1.72,1.72,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1A6,6,0,0,1,171.68,253.47Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.25,257.13c-.39-.22-.7,0-.7.41a1.54,1.54,0,0,0,.7,1.22c.39.23.71.05.71-.4A1.59,1.59,0,0,0,166.25,257.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,251.49a1.82,1.82,0,0,1,3,1.71,4.4,4.4,0,0,1-.12,1l-.47-.27a3.75,3.75,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.26,5.4,5.4,0,0,0-2.43,4.22,2.19,2.19,0,0,0,.2,1,1,1,0,0,0,.42.46l0,0a1.45,1.45,0,0,1,.22.62,1.42,1.42,0,0,1-.52-.19,1.68,1.68,0,0,1-.74-.92,2.91,2.91,0,0,1-.15-1A6,6,0,0,1,168.24,251.49Z",
    style: {
      fill: "#603FEF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,251.49a1.82,1.82,0,0,1,3,1.71,4.72,4.72,0,0,1,0,.64,4.6,4.6,0,0,1,.53-.37,1.82,1.82,0,0,1,3,1.71,3.66,3.66,0,0,1-.06.65,3.23,3.23,0,0,1,.54-.37,2,2,0,0,1,2.07-.18,2,2,0,0,1,.89,1.89,4.76,4.76,0,0,1-.06.64,3.62,3.62,0,0,1,.53-.37,1.82,1.82,0,0,1,3,1.71,3.55,3.55,0,0,1-.06.64,4.7,4.7,0,0,1,.54-.37,1.82,1.82,0,0,1,3,1.71,4.62,4.62,0,0,1-.06.64,3.54,3.54,0,0,1,.53-.36,1.82,1.82,0,0,1,3,1.71,3.55,3.55,0,0,1-.06.64,4,4,0,0,1,.54-.37,1.82,1.82,0,0,1,3,1.71,4.62,4.62,0,0,1-.06.64,4.6,4.6,0,0,1,.53-.37,2.09,2.09,0,0,1,2.08-.18,2,2,0,0,1,.88,1.89,3.66,3.66,0,0,1-.06.65,3.7,3.7,0,0,1,.54-.37,2,2,0,0,1,2.08-.18,2.07,2.07,0,0,1,.88,1.89,4.76,4.76,0,0,1-.06.64,4.6,4.6,0,0,1,.53-.37,1.82,1.82,0,0,1,3,1.71,4.87,4.87,0,0,1-.05.65,3.62,3.62,0,0,1,.53-.37,1.82,1.82,0,0,1,3,1.71,3.63,3.63,0,0,1-.06.64,3.23,3.23,0,0,1,.54-.37,2,2,0,0,1,2.07-.18A2.06,2.06,0,0,1,209,275a4.76,4.76,0,0,1-.06.64,4.6,4.6,0,0,1,.53-.37,1.82,1.82,0,0,1,3,1.71,3.66,3.66,0,0,1-.06.65,3.7,3.7,0,0,1,.54-.37,2,2,0,0,1,2.07-.18,2.06,2.06,0,0,1,.89,1.89,4.76,4.76,0,0,1-.06.64,4.6,4.6,0,0,1,.53-.37,1.82,1.82,0,0,1,3,1.71,4.6,4.6,0,0,1-.05.64,4.6,4.6,0,0,1,.53-.37,2.06,2.06,0,0,1,2.08-.17,2,2,0,0,1,.88,1.88,4.42,4.42,0,0,1-.12,1l-.48-.28a3.63,3.63,0,0,0,.08-.73A1.31,1.31,0,0,0,220,281.7a5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.25,1.25,0,0,0,.42.46l.05,0a1.61,1.61,0,0,1,.22.61,1.39,1.39,0,0,1-.53-.18,1.64,1.64,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6.1,6.1,0,0,1,1.89-4.07l-.26-.15a3.68,3.68,0,0,0,.07-.73,1.56,1.56,0,0,0-.62-1.44,1.6,1.6,0,0,0-1.56.18,5.41,5.41,0,0,0-2.43,4.23,2.15,2.15,0,0,0,.19,1,1.13,1.13,0,0,0,.43.46l0,0a1.46,1.46,0,0,1,.22.61,1.61,1.61,0,0,1-.52-.18,1.74,1.74,0,0,1-.74-.93,3.12,3.12,0,0,1-.15-1,6,6,0,0,1,1.9-4.07l-.27-.15a3.79,3.79,0,0,0,.08-.73,1.57,1.57,0,0,0-.63-1.44,1.55,1.55,0,0,0-1.55.18,5.37,5.37,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.17,1.17,0,0,0,.42.46l0,0a1.61,1.61,0,0,1,.23.62,1.4,1.4,0,0,1-.53-.19,1.61,1.61,0,0,1-.73-.93,2.8,2.8,0,0,1-.15-1,6,6,0,0,1,1.89-4.06l-.26-.16a3.61,3.61,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.25,5.4,5.4,0,0,0-2.44,4.22,2.12,2.12,0,0,0,.2,1,1.16,1.16,0,0,0,.43.47l0,0a1.46,1.46,0,0,1,.22.61,1.66,1.66,0,0,1-.53-.18,1.72,1.72,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6.08,6.08,0,0,1,1.89-4.07l-.26-.15a3.68,3.68,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.39,5.39,0,0,0-2.44,4.23,2.15,2.15,0,0,0,.2,1,1.11,1.11,0,0,0,.42.46l0,0a1.5,1.5,0,0,1,.22.62,1.42,1.42,0,0,1-.52-.19,1.62,1.62,0,0,1-.73-.92,2.89,2.89,0,0,1-.15-1,6,6,0,0,1,1.89-4.07l-.27-.15A3.79,3.79,0,0,0,205,273a1.31,1.31,0,0,0-2.18-1.26,5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.17,1.17,0,0,0,.42.46l.05,0a.34.34,0,1,1-.31.43,1.65,1.65,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6.1,6.1,0,0,1,1.89-4.07l-.26-.15a3.68,3.68,0,0,0,.07-.73,1.57,1.57,0,0,0-.62-1.44,1.6,1.6,0,0,0-1.56.18A5.41,5.41,0,0,0,197,274a2.12,2.12,0,0,0,.19,1,1.07,1.07,0,0,0,.43.46l0,0a1.46,1.46,0,0,1,.22.61,1.61,1.61,0,0,1-.52-.18,1.74,1.74,0,0,1-.74-.93,3.12,3.12,0,0,1-.15-1,6,6,0,0,1,1.9-4.07l-.27-.15a3.79,3.79,0,0,0,.08-.73,1.57,1.57,0,0,0-.63-1.44,1.55,1.55,0,0,0-1.55.18,5.39,5.39,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.11,1.11,0,0,0,.42.46l0,0a1.61,1.61,0,0,1,.23.62,1.4,1.4,0,0,1-.53-.19,1.61,1.61,0,0,1-.73-.93,2.8,2.8,0,0,1-.15-1,6,6,0,0,1,1.89-4.06l-.26-.16a3.61,3.61,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.25,5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.19,1.19,0,0,0,.43.46l0,0a1.46,1.46,0,0,1,.22.61,1.53,1.53,0,0,1-.52-.18,1.66,1.66,0,0,1-.74-.93,2.85,2.85,0,0,1-.15-1,6.1,6.1,0,0,1,1.89-4.07l-.26-.15a3.68,3.68,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.39,5.39,0,0,0-2.44,4.23,2.15,2.15,0,0,0,.2,1,1.11,1.11,0,0,0,.42.46l0,0a.34.34,0,1,1-.3.43,1.68,1.68,0,0,1-.73-.93,2.89,2.89,0,0,1-.15-1,6,6,0,0,1,1.89-4.07l-.27-.15a3.79,3.79,0,0,0,.08-.73,1.31,1.31,0,0,0-2.18-1.26,5.4,5.4,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.18,1.18,0,0,0,.42.46l0,0a1.59,1.59,0,0,1,.22.62,1.68,1.68,0,0,1-.53-.19,1.64,1.64,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6.1,6.1,0,0,1,1.89-4.07l-.26-.15a3.63,3.63,0,0,0,.08-.73,1.59,1.59,0,0,0-.63-1.44,1.56,1.56,0,0,0-1.55.19,5.37,5.37,0,0,0-2.44,4.22,2.12,2.12,0,0,0,.2,1,1.14,1.14,0,0,0,.42.47l0,0a1.63,1.63,0,0,1,.23.61,1.58,1.58,0,0,1-.53-.18,1.68,1.68,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6,6,0,0,1,1.89-4.07l-.26-.15a3.68,3.68,0,0,0,.07-.73,1.31,1.31,0,0,0-2.18-1.26,5.42,5.42,0,0,0-2.44,4.23,2.18,2.18,0,0,0,.2,1,1.13,1.13,0,0,0,.43.46l0,0a1.5,1.5,0,0,1,.22.62,1.53,1.53,0,0,1-.52-.18,1.74,1.74,0,0,1-.74-.93,2.89,2.89,0,0,1-.15-1,6.08,6.08,0,0,1,1.89-4.07l-.26-.15a3.75,3.75,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.37,5.37,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1.17,1.17,0,0,0,.42.46l0,0a1.45,1.45,0,0,1,.22.62,1.63,1.63,0,0,1-.52-.19,1.61,1.61,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6.05,6.05,0,0,1,1.89-4.07l-.27-.15a3.71,3.71,0,0,0,.08-.73,1.57,1.57,0,0,0-.62-1.44,1.59,1.59,0,0,0-1.56.18,5.42,5.42,0,0,0-2.44,4.23,2.12,2.12,0,0,0,.2,1,1,1,0,0,0,.42.46l0,0a1.61,1.61,0,0,1,.22.61,1.58,1.58,0,0,1-.53-.18,1.72,1.72,0,0,1-.73-.93,2.85,2.85,0,0,1-.15-1,6.08,6.08,0,0,1,1.89-4.07l-.26-.15a3.75,3.75,0,0,0,.07-.73,1.31,1.31,0,0,0-2.17-1.26,5.39,5.39,0,0,0-2.44,4.22,2.19,2.19,0,0,0,.2,1,1,1,0,0,0,.42.46l0,0a1.45,1.45,0,0,1,.22.62,1.42,1.42,0,0,1-.52-.19,1.68,1.68,0,0,1-.74-.92,2.91,2.91,0,0,1-.15-1A6,6,0,0,1,168.24,251.49Z",
    style: {
      opacity: 0.4
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M212.79,186.79c-15.62,3-18.87,3.55-27.16,15.8-8.17,12.08-15.79,24.17-26.83,41-5.18,7.89-5.36,10.75-1.68,20.62,2.62,7,7.64,18.91,10.77,26.13a106.65,106.65,0,0,1,6.38,17.51c.58,2.32,1,4.69,1.59,7a19.23,19.23,0,0,1,.63,2.65,7.42,7.42,0,0,0,1.32,2.78,4.55,4.55,0,0,0,2.88,2.26c1.15.25,2,.39,2.66,1.45a17.79,17.79,0,0,0,1.87,2.91,5.45,5.45,0,0,0,3.57,1.67,5.5,5.5,0,0,1,2.68.46c1.73.92,2.75,2.44,4.94,1.75a17.4,17.4,0,0,0,2.91-1.26c1-.59,1.93-1.16,1.93-1.16l-3.71-2.16c-2.8-4.07-4.47-12.75-3.9-13.91s3.22,1.39,4.1,1.85c2.84,1.51,4.67,2,6.3.69.88-.7,0-1.55-.7-2.22a29,29,0,0,1-3.44-4.1c-2-2.83-3-4.89-5.76-7.47-1.5-1.41-3.33-3.12-4.55-4.48-3.4-3.8-4.69-11.56-6.84-20.76-1-4.31-3.94-17.91-3.94-17.91l30.94-32.14S210.32,197.3,212.79,186.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.81,257.89c-1.14-3.52-5.86-7.5-9.12-8.24,4.74-.73,8.64,2.3,10.75,6.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.52 231.19 212.79 222.65 205.78 235.16 204.52 231.19",
    style: {
      fill: "#f28f8f"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.3c087c0807531cefd1ded2014ba31161.svg";
export { ForwardRef as ReactComponent };